<template lang="pug">
  b-container(fluid)
    b-modal(id="modal-1", title="SIZE ESTIMATION (Work in progress)")
      h6 Experts' minimum area
      p
        i The experts' minimum area is based on an experts' assessment of each technology. It is calculated as a function of people equivalent (PE) and climate. Likewise, PE is estimated as a function of the people served by the technology and the type of water.

      h6 Data-driven surface estimation
      p
        i These areas are calculated independently for each compound and represent the area required to treat a specific compound from the specified inflow concentration to the effluent concentration. The user must understand that, in case more than one compound is to be removed, only the largest value of surface area shown is the one that will allow to treat all of the studied compounds.
      p
        i The surfaces are estimated by comparing the R<sup>2</sup> of three different regression models: linear, exponential and power regressions. The models are trained with the case-studies dataset, where you can contribute with your own case-studies and, thus, increase the accuracy of the estimations.
      p
        i When there are less than 5 valid observations for a combination of technology and pollutant, the models are not trained for that specific case, the application shows "--".
      p
        i The range of surface represents the 95% confidence interval as estimated by the most accurate regression model.




    b-row
      b-col.mb-3.p-0
        GeneralMenu
    b-row.thirdPart.pb-5
      b-col(cols="3")
      b-col(cols="6")
        h2.text-center Find your NBS
        div.line
        p.text-center When the user has fulfilled the interactive menus of the left side of this page, a list of NBS capable of work under the specified conditions are shown below. Each NBS is shown with its name, a picture, short description, the pollutants/nutrient it is able to remove and pictograms that describes the co-benefits it has, the knowledge requirements of the operators, the maintenance level and biohazard level. By passing the cursor over these pictograms, the user can see the description of each.
      b-col(cols="3")
    b-row.pt-5
      b-col.pl-5
        b-row.p-0.border-bottom.pb-2.mb-3
          b-col.p-0
            a(type="button" v-b-toggle.ecsLgs style="") LEGEND
            b-icon(v-b-toggle.ecsLgs icon="chevron-up" size="sm").float-right
        b-row.p-0
          b-col.p-0.legendText
            b-collapse.collapsed(id="ecsLgs")
              b-row.pb-3
                b-col
                b-col High
                b-col Medium
                b-col Low
              b-row
                b-col
                  b-row.pb-1.align-items-center
                    b-col
                      b Eco. services
                    b-col
                      div(style="background: seagreen; width: 100%;height: 45px;float: left;padding: 1px;margin-right: 0px;")
                    b-col
                      div(style="background: mediumseagreen; width: 100%;height: 45px;float: left;padding: 1px;margin-right: 0px;")
                    b-col
                      div(style="background: darkseagreen; width: 100%;height: 45px;float: left;padding: 1px;margin-right: 0px;")
                  b-row.pb-1.align-items-center
                    b-col
                      b-row
                        b-col
                          b-row.align-items-center
                            b-col
                              b Cost
                            b-col
                              div(style="background: darkblue;width: 100%;height: 45px;float: left;padding: 1px;margin-right: 0px;")
                            b-col
                              div(style="background: dodgerblue;width: 100%;height: 45px;float: left;padding: 1px;margin-right: 0px;")
                            b-col
                              div(style="background: lightblue;width: 100%;height: 45px;float: left;padding: 1px;margin-right: 0px;")
                  b-row.pb-1.align-items-center
                    b-col
                      b-row.align-items-center
                        b-col
                          b Biohazard
                        b-col
                          div(style="background: orangered;width: 100%;height: 45px;float: left;padding: 1px;margin-right: 0px;")
                        b-col
                          div(style="background: orange;width: 100%;height: 45px;float: left;padding: 1px;margin-right: 0px;")
                        b-col
                          div(style="background: palegoldenrod;width: 100%;height: 45px;float: left;padding: 1px;margin-right: 0px;")
              b-row.pt-3
                b-col
                  p Outputs must be critically analysed and combined by the user in order to get to a sensible conclusion of which NBS is a good option for his/her requirements.
        b-row.p-0.border-bottom.pb-2.mb-3
          b-col.p-0
            a(type="button" v-b-toggle.systemCriteria style="") EXPERT DRIVEN APPROACH FILTER
            b-icon(v-b-toggle.systemCriteria icon="chevron-up" size="sm").float-right
        b-row.p-0
          b-col.p-0.legendText
            b-collapse.collapsed(visible id="systemCriteria")
              #app2.col-md-12.p-0
                aside
                  // Household start
                  p.mediumText Complete the selection criteria below to identify which NBS types are most appropriate for your wastewater treatment conditions. For the resulting NBS types, icons are provided to indicate expected co-benefits (green), costs (blue), and biohazard risks (red). The relative magnitude of these elements is further indicated by color shading (hover over the icons for additional information).
                  section.widget.widget_text.pb-3
                    h2#widget-title System scale
                    p.littleText Select ‘Treatment for single household’ to explore options for family household wastewater sanitation. For treatment of multi-household or community-scale systems, leave this option unselected.
                    .textwidget
                      .form-check
                        label.form-check-label(for='household-building-solutions-check')
                          input#household-building-solutions-check.form-check-input(type='checkbox' name='household-building-solutions-check' value='household_building_solutions' v-model='checkedHousehold' @change='filtering()')
                          |                                         Treatment for single household
                  // Household end
                  // Water type start
                  section.widget.widget_text.pb-3
                    h2#widget-title Type of wastewater
                    p.littleText Select the type of influent wastewater to be treated. Hovering over the (?) icon will bring up a tooltip with additional explanations. If the water type is unknown, select ‘Any’.
                    .textwidget
                      .form-check
                        label.form-check-label(for='any-wastewater-check' style='padding-bottom: 5px;')
                          input#any-wastewater-check.form-check-input(type='radio' name='any-wastewater-check' value='any_wastewater' v-model='checkedType' @change='filtering()')
                          |                                         Any
                          sup(data-placement='right' data-toggle='tooltip' :title="'Any wastewater.'")
                            i.far.fa-question-circle(style='font-size: 12px; margin-left:14px; cursor:default; color:#404040')
                      .form-check
                        label.form-check-label(for='raw-domestic-wastewater-check' style='padding-bottom: 5px;')
                          input#raw-domestic-wastewater-check.form-check-input(type='radio' name='raw-domestic-wastewater-check' value='raw_domestic_wastewater' v-model='checkedType' @change='filtering()')
                          |                                         Raw domestic wastewater
                          sup(data-placement='right' data-toggle='tooltip' :title="'Domestic wastewater without receiving any pretreatment.'")
                            i.far.fa-question-circle(style='font-size: 12px; margin-left:14px; cursor:default; color:#404040')
                      .form-check
                        label.form-check-label(for='pretreated-domestic-wastewater-check' style='padding-bottom: 5px;')
                          input#pretreated-domestic-wastewater-check.form-check-input(type='radio' name='pretreated-domestic-wastewater-check' value='pretreated_domestic_wastewater' v-model='checkedType' @change='filtering()')
                          |                                         Pre-treated domestic wastewater
                          sup(data-placement='right' data-toggle='tooltip' title='Domestic wastewater which has passed through a pretreatment, e.g. septic tank.')
                            i.far.fa-question-circle(style='font-size: 12px; margin-left:14px; cursor:default; color:#404040' )
                      .form-check
                        label.form-check-label(for='greywater-check' style='padding-bottom: 5px;')
                          input#greywater-check.form-check-input(type='radio' name='greywater-check' value='greywater' v-model='checkedType' @change='filtering()')
                          |                                         Greywater
                          sup(data-placement='right' data-toggle='tooltip' title='Greywater is that component of sewage which does not come from a toilet or urinal. Greywater is the wastewater which is generated from the use of a shower, bath tub, spa bath, hand basin, laundry tub, clothes washing machine, kitchen sink, and dishwasher.')
                            i.far.fa-question-circle(style='font-size: 12px; margin-left:14px; cursor:default; color:#404040' )
                      .form-check
                        label.form-check-label(for='secondary-treated-wastewater-check' style='padding-bottom: 5px;')
                          input#secondary-treated-wastewater-check.form-check-input(type='radio' name='secondary-treated-wastewater-check' value='secondary_treated_wastewater' v-model='checkedType' @change='filtering()')
                          |                                         Secondary treated wastewater
                          sup(data-placement='right' data-toggle='tooltip' title='Domestic wastewater which has been passed through a secondary treatment, e.g. an activated sludge system, and needs further polishing.')
                            i.far.fa-question-circle(style='font-size: 12px; margin-left:14px; cursor:default; color:#404040' )
                      .form-check
                        label.form-check-label(for='cso-discharge-water-check' style='padding-bottom: 5px;')
                          input#cso-discharge-water-check.form-check-input(type='radio' name='cso-discharge-water-check' value='cso_discharge_water' v-model='checkedType' @change='filtering()')
                          |                                         CSO discharge water
                          sup(data-placement='right' data-toggle='tooltip' title='Raw domestic wastewater diluted by storm water, which is discharged from combined sewer overflow structures.')
                            i.far.fa-question-circle(style='font-size: 12px; margin-left:14px; cursor:default; color:#404040' )
                      .form-check
                        label.form-check-label(for='river-diluted-wastewater-check')
                          input#river-diluted-wastewater-check.form-check-input(type='radio' name='river-diluted-wastewater-check' value='river_diluted_wastewater' v-model='checkedType' @change='filtering()')
                          |                                         River diluted wastewater
                          sup(data-placement='right' data-toggle='tooltip' title='Secondary treated wastewater diluted by river water.')
                            i.far.fa-question-circle(style='font-size: 12px; margin-left:14px; cursor:default; color:#404040' )
                  // Water type end
                  // Treatment level target start
                  section.widget.widget_text.pb-3
                    h2#widget-title Types of pollutants
                    p.littleText Select the primary pollutants/nutrients target for removal. Multiple pollutant types can be selected.
                    .textwidget
                      .form-check
                        label.form-check-label(for='c-removal-check' style='padding-bottom: 5px;')
                          input#c-removal-check.form-check-input(type='checkbox' name='c-removal-check' value='c_removal' v-model='checkedTags' @change='filtering()')
                          |                                         Organic matter (Carbon)
                      .form-check
                        label.form-check-label(for='n-removal-nitrification-check' style='padding-bottom: 5px;')
                          input#n-removal-nitrification-check.form-check-input(type='checkbox' name='n-removal-nitrification-check' value='n_removal_nitrification' v-model='checkedTags' @change='filtering()')
                          |                                         Nutrients (Ammonium NH<sub>4</sub><sup>+</sup>)
                          sup(data-placement='right' data-toggle='tooltip' title='Nitrification')
                            i.far.fa-question-circle(style='font-size: 12px; margin-left:14px; cursor:default' )
                      .form-check
                        label.form-check-label(:class="" for='n-removal-nitrateremoval-check' style='padding-bottom: 5px;')
                          input#n-removal-nitrateremoval-check.form-check-input(type='checkbox' name='n-removal-nitrateremoval-check' value='n_removal_nitrateremoval' v-model='checkedTags' @change='filtering()')
                          |                                         Nutrients (Nitrate NO<sub>3</sub><sup>-</sup>)
                          sup(data-placement='right' data-toggle='tooltip' title='Denitrification, Assimilation, Adsorption...')
                            i.far.fa-question-circle(style='font-size: 12px; margin-left:14px; cursor:default' )
                      .form-check
                        label.form-check-label(for='p-removal-check')
                          input#p-removal-check.form-check-input(type='checkbox' name='p-removal-check' value='p_removal' v-model='checkedTags' @change='filtering()')
                          |                                         Nutrients (Phosphate PO<sub>4</sub><sup>3-</sup>)
                          sup(data-placement='right' data-toggle='tooltip' title='Precipitation, Assimilation...')
                            i.far.fa-question-circle(style='font-size: 12px; margin-left:14px; cursor:default')
                  // Treatment level target end
                  // Ratio start
                  section.widget.widget_text.pt-4.pl-4.pr-4(style='padding-bottom: 0px' :class="{tofillSection: area_input.length === 0 || inhabitants_input.length === 0 || checkedClimate.length === 0}")
                    h2#widget-title People served
                    p.littleText Estimated number of people producing wastewater for the designated system.
                    .textwidget(style='height: 30px')
                      .form-check
                        input#inhabitants_input.form-check-input(style='width: 100%; height: 30px;' type='number' pattern='\d*' validate='' v-model='inhabitants_input' min='0' @change='filtering()')
                        br
                    div(:class='{hidden:inhabitants_input < 20000}') Consider multilocation or parallel line.
                    div(:class="{hidden:inhabitants_input < 50000 || (checkedType !== 'raw_domestic_wastewater' && checkedType !== 'pretreated_domestic_wastewater')}") Recomend not using NBS.
                  // Ratio end
                  // Area start
                  section.widget.widget_text.p-4(:class="{ tofillSection: area_input.length === 0 || inhabitants_input.length === 0 || checkedClimate.length === 0}")
                    h2#widget-title()
                      | Available surface area (m
                      sup 2
                      | )
                    p.littleText Estimated land surface area  (in square meters) available for development of wastewater treatment.
                    .textwidget
                      .form-check
                        input#area_input.form-check-input(style='width: 100%; height: 30px;' type='number' v-model='area_input' min='0' @change='filtering()')
                        br
                  // Area end
                  // Climate start
                  section.widget.widget_text.p-4(:class="{ tofillSection: area_input.length === 0 || inhabitants_input.length === 0 || checkedClimate.length === 0}")
                    h2#widget-title
                      | Climate
                      sup
                        i.far.fa-question-circle(style='font-size: 14px; margin-left:2px; cursor:default; color:#404040' data-placement='right' data-toggle='tooltip' title='Select climate type according to Köppen classification. You can figure out which climate type  applies to your city in this web-site: www.weatherbase.com')
                    p.littleText Specify the climate region for the project location according to the Köppen classification. To identify your climate region, consult <a href="http:\\www.weatherbase.com" target="_blank">Weatherbase</a>.
                    .textwidget
                      .form-check
                        label.form-check-label(for='ratio-tropical-climate-check')
                          input#ratio-tropical-climate-check.form-check-input(type='radio' name='ratio-tropical-climate-check' value='ratio_tropical_climate' v-model='checkedClimate' @change='filtering()')
                          |                                         Tropical / Megathermal
                      .form-check
                        label.form-check-label(for='ratio-dry-climate-check')
                          input#ratio-dry-climate-check.form-check-input(type='radio' name='ratio-dry-climate-check' value='ratio_dry_climate' v-model='checkedClimate' @change='filtering()')
                          |                                         Dry (desert and semi-arid)
                      .form-check
                        label.form-check-label(for='ratio-temperate-climate-check')
                          input#ratio-temperate-climate-check.form-check-input(type='radio' name='ratio-temperate-climate-check' value='ratio_temperate_climate' v-model='checkedClimate' @change='filtering()')
                          |                                         Temperate / Mesothermal
                      .form-check
                        label.form-check-label(for='ratio-continental-climate-check')
                          input#ratio-continental-climate-check.form-check-input(type='radio' name='ratio-continental-climate-check' value='ratio_continental_climate' v-model='checkedClimate' @change='filtering()')
                          |                                         Continental / Microthermal
                  // Climate end
                  // Energy start
                  section.widget.widget_text(:id='filter_energy.id').mt-4
                    h2#widget-title(v-html='filter_energy.name')
                    p.littleText Specify whether to limit NBS to those with low energy requirements such as gravity-fed systems. Leave unselected to include all NBS types regardless of energy requirements.
                    div
                      .textwidget
                        .form-check(v-for='tag in filter_energy.tags')
                          label.form-check-label(:for="filter_energy.id+'-'+tag[1]" style='padding-bottom: 5px;')
                            input.form-check-input(type='checkbox' :id="filter_energy.id+'-'+tag[1]" :name="filter_energy+'-'+tag[1]" :value='tag[1]' v-model='checkedEnergy' @change='filtering()')
                            |                                         Low
                  // Energy end
                // Clear all button

                b-button(squared variant="outline-primary" @click='clearAllCheckboxes()').buttonStyle.mt-3.mb-3 CLEAR ALL

        b-row.p-0.border-bottom.pb-2.mb-3
          b-col.p-0
            a(type="button" v-b-toggle.systemPerformance style="") DATA DRIVEN APPROACH CALCULATION (Work in progress)
            b-icon(v-b-toggle.systemPerformance icon="chevron-up" size="sm").float-right
        b-row.p-0
          b-col.p-0.legendText
            b-collapse.collapsed(visible id="systemPerformance")
              b-col(cols=12)
                b-row.p-0
                  p.mediumText
                    i After identifying which NBS types are most appropriate for your wastewater treatment conditions, complete the information below in order to estimate the land surface area required to achieve specific pollutant removal targets. These estimates are derived from mathematical formulas which describe pollutant reduction performance for each NBS type, based on reviewed <a href="/casefilter">scientific publications</a>. <br><i> Note that this is an ongoing work, and the area estimates should be considered as rough estimates. The more case-studies are introduced in the online database, the more reliable the estimates are going to be, as the mathematical formulas are fitted with the uploaded case-studies. Furthermore, there’s an ongoing EU 2020 project (MULTISOURCE) working on this data-driven approach, thus more reliable equations will be soon available. </i>
                  h2#widget-title Volume i people served
                  p.littleText Enter the expected wastewater inflow rate (cubic meters per day) and population served.
                  b-form-group(label-cols="4" label="" label-align="left")
                    b-input-group(append="m3/day")
                      b-form-input(id="inflow" name="inflow" type="number" v-model.trim="inflow" @change="changeInflow(inflow)")
                  b-form-group(label-cols="4" label="" label-align="left")
                    b-input-group(append="people")
                      b-form-input(id="inflow-pe" name="inflow-pe" type="number" v-model.trim="inflow_pe" @change="changeInflowPE(inflow_pe)")
                //b-row.mb-0
                  b-col(cols="12").p-0
                    h2#widget-title Select legal reuse (optional):
                    p.littleText The user can choose a country or international institution and a water reuse currently applied for the country/institution water-reuse regulations. Each of the selected options will automatically fulfill the below limiting concentrations.
                //b-row
                  b-col(cols="12").p-0
                    label.labelReuse Countries/Institutions
                    b-form-select(v-model="country" :options="countries")
                    label.labelReuse Reuse
                    b-form-select(v-model="reuse_sel" :options="reuse_options" text-field="title")
                b-row
                  b-col
                    b-row.mt-3.mb-2
                      b-col(cols="12").p-0
                        h2#widget-title Input values:
                        p.littleText For each targeted wastewater pollutant, enter both the expected influent concentration and the targeted effluent concentration for your system. For each pollutant type, the expected concentration units are noted. Surface area estimates will not be displayed unless values are provided for both influent and effluent.
                      b-col(cols="2")
                      b-col.text-center Input
                      b-col Output
                    b-row
                      b-col(cols=2).pr-0
                        label.labelStyle.mt-1 BOD
                      b-col
                        b-form-group

                          b-input-group
                            b-form-input(:id="'bod'+'_in'" :name="'bod'+'_in'" type='number' v-model="inputs.bod_in")
                            b-form-input(:id="'bod'+'_out'" :name="'bod'+'_out'" type='number' v-model="inputs.bod_out" @keyup.enter="sendInputValues")
                            b-input-group-append
                              div.input-group-text mgO<sub>2</sub>/L
                    b-row
                      b-col(cols=2).pr-0
                        label.labelStyle.mt-1 TN
                      b-col
                        b-form-group
                          b-input-group(:append="'mg/L'")
                            b-form-input(:id="'tn'+'_in'" :name="'tn'+'_in'" type='number' v-model="inputs.tn_in")
                            b-form-input(:id="'tn'+'_out'" :name="'tn'+'_out'" type='number' v-model="inputs.tn_out" @keyup.enter="sendInputValues")
                    b-row
                      b-col(cols=2).pr-0
                        label.labelStyle.mt-1 NO<sub>3</sub><sup>-</sup>N
                      b-col
                        b-form-group()
                          b-input-group(:append="'mgN/L'")
                            b-form-input(:id="'no3'+'_in'" :name="'no3'+'_in'" type='number' v-model="inputs.no3_in")
                            b-form-input(:id="'no3'+'_out'" :name="'no3'+'_out'" type='number' v-model="inputs.no3_out" @keyup.enter="sendInputValues")
                    b-row
                      b-col(cols=2).pr-0
                        label.labelStyle.mt-1 NH<sub>4</sub><sup>+</sup>-N
                      b-col
                        b-form-group()
                          b-input-group(:append="'mgN/L'")
                            b-form-input(:id="'nh4'+'_in'" :name="'nh4'+'_in'" type='number' v-model="inputs.nh4_in")
                            b-form-input(:id="'nh4'+'_out'" :name="'nh4'+'_out'" type='number' v-model="inputs.nh4_out" @keyup.enter="sendInputValues")
                    b-row
                      b-col(cols=2).pr-0
                        label.labelStyle.mt-1 TP
                      b-col
                        b-form-group()
                          b-input-group(:append="'mgP/L'")
                            b-form-input(:id="'tp'+'_in'" :name="'tp'+'_in'" type='number' v-model="inputs.tp_in")
                            b-form-input(:id="'tp'+'_out'" :name="'tp'+'_out'" type='number' v-model="inputs.tp_out" @keyup.enter="sendInputValues")
                    b-row
                      b-col(cols=2).pr-0
                        label.labelStyle.mt-1 PO<sub>4</sub><sup>3-</sup>-P
                      b-col
                        b-form-group()
                          b-input-group(:append="'mgP/L'")
                            b-form-input(:id="'po43'+'_in'" :name="'po43'+'_in'" type='number' v-model="inputs.po43_in")
                            b-form-input(:id="'po43'+'_out'" :name="'po43'+'_out'" type='number' v-model="inputs.po43_out" @keyup.enter="sendInputValues")
                    b-row
                      b-col(cols=2).pr-0
                        label.labelStyle.mt-1 E.coli
                      b-col
                        b-form-group()
                          b-input-group(:append="'CFU/L'")
                            b-form-input(:id="'ecoli'+'_in'" :name="'ecoli'+'_in'" type='number' v-model="inputs.ecoli_in")
                            b-form-input(:id="'ecoli'+'_out'" :name="'ecoli'+'_out'" type='number' v-model="inputs.ecoli_out" @keyup.enter="sendInputValues")
                    b-row
                      b-col(cols=2).pr-0
                        label.labelStyle.mt-1 H.eggs
                      b-col
                        b-form-group()
                          b-input-group(:append="'eggs/L'")
                            b-form-input(:id="'heggs'+'_in'" :name="'heggs'+'_in'" type='number' v-model="inputs.heggs_in")
                            b-form-input(:id="'heggs'+'_out'" :name="'heggs'+'_out'" type='number' v-model="inputs.heggs_out" @keyup.enter="sendInputValues")

                b-row
                  b-col
                    b-button(squared variant="outline-success" @click="sendInputValues").buttonStyle.mt-3.mb-3 ESTIMATE SURFACE
                  b-col
                    b-button(squared variant="outline-primary" @click='clearAllInputValues()').buttonStyle.mt-3.mb-3 CLEAR ALL
      // Right column (technologies) start
      #content-body.col-md-9
        #solutions-container
          b-container#app(fluid)
            .col-md-12.solution-container
              b-row.pt-0.pb-0.border-bottom
                b-col(cols="8").mr-5
                  b-row.pb-2.mb-0
                    b-col.p-0
                      a(type="button" style="") SELECTED NATURE-BASED SOLUTIONS
                b-col
                  b-row
                    b-col.p-0
                      a(type="button" style=""  v-b-modal.modal-1) SIZE ESTIMATION (Work in progress)
                        i.far.fa-question-circle(style='font-size: 12px; margin-left:4px; cursor:default; color:#404040')
            .col-md-12.solution-container(:id='item.id' v-for='(item, index) in technologies_printed[0]')
              a(:href='item.link' target='_blank')
                .thumbnail
                  b-row.pt-4.pb-2.border-bottom
                    b-col(cols="8").mr-5
                      b-row
                        b-col(cols=6)
                          b-row
                            b-col
                              img(:src="'/img/'+item.image" :alt='item.name' style='width:100%')
                        b-col(cols="6")
                          .caption
                            b-row
                              b-col.p-0
                                h2.solution-title(:id="item.id.trim()+'_title'") {{ item.name }}&nbsp;
                            b-row
                              b-col
                                b-row.tags-container
                                  b-col
                                    b-row
                                      b-col.p-0
                                        span.littleText Target pollutans
                                          i.far.fa-question-circle(style='font-size: 12px; margin-left:4px; cursor:default; color:#404040' data-placement='right' data-toggle='tooltip' title='The blue and grey colours indicate whether the NBS is designed to remove (blue) or not to remove that specific contaminant (grey).' )
                                    b-row.mt-2
                                      b-col.p-0
                                        b-badge(class="badge-custom" :variant="(item.c_removal === 'active') ? 'primary' : 'secondary'") Carbon
                                      b-col.pt-1
                                        b-badge(class="badge-custom" :variant="(item.n_removal_nitrification === 'active') ? 'primary' : 'secondary'").float-right Ammonium NH<sub>4</sub><sup>+</sup>
                                    b-row.pt-1
                                      b-col.p-0
                                        b-badge(class="badge-custom" :variant="(item.n_removal_nitrateremoval === 'active') ? 'primary' : 'secondary'") Nitrate NO<sub>3</sub><sup>-</sup>
                                      b-col.pt-1
                                        b-badge(class="badge-custom" :variant="(item.p_removal === 'active') ? 'primary' : 'secondary'").float-right Phosphate PO<sub>4</sub><sup>3-</sup>

                                    b-row.mt-3.tags
                                      b-col.m-0.p-0
                                        span.legend2(:class='item.es_biodiversity_fauna.trim()' data-html='true' data-toggle='tooltip' data-placement='bottom' :title="'<div>Fauna '+legend_co+'</div>'")
                                          i.fas.fa-paw
                                        span.legend2(:class='item.es_biodiversity_flora.trim()' data-html='true' data-toggle='tooltip' data-placement='bottom' :title="'<div>Flora'+legend_co+'</div>'")
                                          i.fas.fa-spa
                                        span.legend2(:class='item.es_temperature_regulation.trim()' data-html='true' data-toggle='tooltip' data-placement='bottom' :title="'<div>Temperature regulation'+legend_co+'</div>'")
                                          i.fas.fa-thermometer-half
                                        span.legend2(:class='item.es_flood_mitigation.trim()' data-html='true' data-toggle='tooltip' data-placement='bottom' :title="'<div>Flood mitigation'+legend_co+'</div>'")
                                          i.fas.fa-water
                                        span.legend2(:class='item.es_storm_peak_mitigation.trim()' data-html='true' data-toggle='tooltip' data-placement='bottom' :title="'<div>Storm peak mitigation'+legend_co+'</div>'")
                                          i.fas.fa-cloud-rain
                                        span.legend2(:class='item.es_carbon_sequestration.trim()' data-html='true' data-toggle='tooltip' data-placement='bottom' :title="'<div>Carbon sequestration'+legend_co+'</div>'")
                                          i.fas.fa-sync
                                        span.legend2(:class='item.es_biomass_production.trim()' data-html='true' data-toggle='tooltip' data-placement='bottom' :title="'<div>Biomass production'+legend_co+'</div>'")
                                          i.fab.fa-pagelines
                                        span.legend2(:class='item.es_aesthetic_value.trim()' data-html='true' data-toggle='tooltip' data-placement='bottom' :title="'<div>Aesthetic value'+legend_co+'</div>'")
                                          i.fas.fa-camera
                                        span.legend2(:class='item.es_recreation.trim()' data-html='true' data-toggle='tooltip' data-placement='bottom' :title="'<div>Recreation'+legend_co+'</div>'")
                                          i.fas.fa-running
                                        span.legend2(:class='item.es_pollination.trim()' data-html='true' data-toggle='tooltip' data-placement='bottom' :title="'<div>Pollination'+legend_co+'</div>'")
                                          i.fas.fa-bug
                                        span.legend2(:class='item.es_food_source.trim()' data-html='true' data-toggle='tooltip' data-placement='bottom' :title="'<div>Food source'+legend_co+'</div>'")
                                          i.fas.fa-apple-alt
                                        span.legend2(:class='item.es_water_reuse.trim()' data-html='true' data-toggle='tooltip' data-placement='bottom' :title="'<div>Water reuse'+legend_co+'</div>'")
                                          i.fas.fa-tint
                                        span.legend2(:class='item.es_biosolids.trim()' data-html='true' data-toggle='tooltip' data-placement='bottom' :title="'<div>Biosolids'+legend_co+'</div>'")
                                          i.fas.fa-dumpster
                                    b-row
                                      b-col.m-0.p-0
                                        span.legend3(:class='item.inv_es_manpower.trim()' data-html='true' data-toggle='tooltip' data-placement='bottom' :title="'<div>Manpower'+legend_op+'</div>'")
                                          i.fas.fa-tools
                                        span.legend3(:class='item.inv_es_skills.trim()' data-html='true' data-toggle='tooltip' data-placement='bottom' :title="'<div>Skilled crew'+legend_op+'</div>'")
                                          i.fas.fa-graduation-cap
                                    b-row
                                      b-col.m-0.p-0
                                        span.legend4(:class='item.inv_es_biohazard.trim()' data-html='true' data-toggle='tooltip' data-placement='bottom' :title="'<div>Biohazard'+legend_bio+'</div>'")
                                          i.fas.fa-biohazard
                                    b-row.align-items-center.mt-3
                                      b-col.pl-0
                                        b-button(v-if="item.factsheet_filenames" squared variant="outline-primary" target="_blank" :href="/factsheets/+item.factsheet_filenames" style="width: 100%").buttonStyle.mb-3 Download
                                    b-row
                                      b-col.pl-0
                                        b-button(variant="outline-secondary" :href="'/nbslist#'+item.type" v-if='foo(item)' squared).buttonStyleFact.float-right {{ type_options[item.type] }}
                    b-col
                      b-row
                        b-col
                          span(style="color: #00ACE5" v-if="area_input") Available area: {{ area_input }} m<sup>2</sup>
                          b-row
                            b-col
                              span(style="color: #00ACE5" v-if="expertArea(item.id)") Experts' minimum area: {{expertArea(item.id)}} m<sup>2</sup>
                          b-row(v-if="estimate_surface")
                            b-col
                              span(v-if="estimateArea(item.id, 'bod')")
                                FormulaResult(pollutanId="bod" label="BOD" :formulaResult="estimateArea(item.id, 'bod')" :allFormulas="item.functionBOD" :id_tech="item.id" :tech="item")
                              span(v-if="estimateArea(item.id, 'tn')")
                                FormulaResult(pollutanId="tn" label="TN" :formulaResult="estimateArea(item.id, 'tn')" :allFormulas="item.functionTN" :id_tech="item.id" :tech="item")
                              //span(v-if="showSize('cod')")
                                FormulaResult(pollutanId="cod" label="COD" :formulaResult="calcFormula('cod',item.functionCOD)" :allFormulas="item.functionCOD" :id_tech="item.id" :tech="item")
                              span(v-if="estimateArea(item.id, 'no3')")
                                FormulaResult(pollutanId="no3" label="NO<sub>3</sub><sup>-</sup>N" :formulaResult="estimateArea(item.id, 'no3')" :allFormulas="item.functionNO3" :id_tech="item.id" :tech="item")
                              span(v-if="estimateArea(item.id, 'nh4')")
                                FormulaResult(pollutanId="nh4" label="NH<sub>4</sub><sup>+</sup>-N" :formulaResult="estimateArea(item.id, 'nh4')" :allFormulas="item.functionNH4" :id_tech="item.id" :tech="item")
                              span(v-if="estimateArea(item.id, 'tp')")
                                FormulaResult(pollutanId="tp" label="TP" :formulaResult="estimateArea(item.id, 'tp')" :allFormulas="item.functionTP" :id_tech="item.id" :tech="item")
                              span(v-if="estimateArea(item.id, 'po43')")
                                FormulaResult(pollutanId="po43" label="PO<sub>4</sub><sup>3-</sup>-P" :formulaResult="estimateArea(item.id, 'po43')" :allFormulas="item.functionPO43" :id_tech="item.id" :tech="item")
                              span(v-if="estimateArea(item.id, 'heggs')")
                                FormulaResult(pollutanId="heggs" label="HEGGS" :formulaResult="estimateArea(item.id, 'heggs')" :allFormulas="item.functionHEGGS" :id_tech="item.id" :tech="item")
                              span(v-if="estimateArea(item.id, 'ecoli')")
                                FormulaResult(pollutanId="ecoli" label="ECOLI" :formulaResult="estimateArea(item.id, 'ecoli')" :allFormulas="item.functionECOLI" :id_tech="item.id" :tech="item")


      // Right column (technologies) end

</template>

<script>

  import GeneralMenu from '@/components/GeneralMenu.vue'
  import FormulaResult from '@/components/helpers/formulaResult.vue'
  const axios = require('axios');
  const ss = require('simple-statistics');

  const DEBUG_MODE = false;

  export default {
    name: "Explore",
    components:{GeneralMenu, FormulaResult},
    computed: {
      technologies_printed: function () {
        return this.technologies_alpha;
        if(this.ordering === "cost") return this.technologies_cost;
        if(this.ordering === "cobenefits") return this.technologies_cobenefits;
        if(this.ordering === "operation") return this.technologies_operation;
        else return this.technologies_alpha;
      },
      reuse_options(){
        if (this.country === "") return [];
        else {
          return this.reuse[this.country];
        }
      }
    },
    data: function(){
      return{
        country: "",
        reuse_sel: {},
        type_options: {
          "CW":'Constructed wetlands' ,
          "GR":'Green Roof' ,
          "GW":'Green Wall' ,
          "HA":'Hydroponics/Aquaponics' ,
          "MS":'Multi Stage' ,
          "I-SRS":'In-stream retention systems ' ,
          "NW":'Natural Wetlands' ,
          "PL":'Ponds/Lagoons' ,
          "SIS":'Soil infiltration systems' ,
          "WS":'Willow systems'
        },
        dataAll:[],
        inflow:1000*0.12,
        inflow_pe: 1000,
        inflow_cont:{},
        outflow_cont:{},
        inputs:{
          bod_in: "",
          bod_out: "",
          cod_in: "",
          cod_out: "",
          tn_in: "",
          tn_out: "",
          no3_in: "",
          no3_out: "",
          nh4_in: "",
          nh4_out: "",
          tp_in: "",
          tp_out: "",
          po43_in: "",
          po43_out: "",
          ecoli_in: "",
          ecoli_out: "",
          heggs_in: "",
          heggs_out: "",
        },

        ordering: 'cobenefits',

        technologies: [],
        technologies_alpha: [],
        technologies_cost: [],
        technologies_cobenefits: [],
        technologies_operation: [],
        legend_co: `<div class='my-legend'>
                        <div class='legend-scale'>
                          <ul class='legend-labels'>
                            <li><span style='background:seagreen;'></span>High</li>
                            <li><span style='background:mediumseagreen;'></span>Medium</li>
                            <li><span style='background:darkseagreen;'></span>Low</li>
                          </ul>
                        </div>
                    </div>`,
        legend_op: `<div class='my-legend'>
                        <div class='legend-scale'>
                          <ul class='legend-labels'>
                            <li><span style='background:darkblue;'></span>High</li>
                            <li><span style='background:dodgerblue;'></span>Medium</li>
                            <li><span style='background:lightblue;'></span>Low</li>
                          </ul>
                        </div>
                    </div>`,
        legend_bio: `<div class='my-legend'>
                        <div class='legend-scale'>
                          <ul class='legend-labels'>
                            <li><span style='background:orangered;'></span>High</li>
                            <li><span style='background:orange;'></span>Medium</li>
                            <li><span style='background:palegoldenrod;'></span>Low</li>
                          </ul>
                        </div>
                    </div>`,
        // Checkboxes checked
        checkedTags: [],
        checkedHousehold: [],
        checkedType: 'any_wastewater',
        checkedClimate: [],
        checkedEnergy: [],
        area_input: '',
        inhabitants_input: '',

        // Technologies data
        filter_c_removal: [],
        filter_n_removal_nitrification: [],
        filter_n_removal_nitrateremoval: [],
        filter_p_removal: [],

        // household_building_solutions
        filter_household_building_solutions: [],

        // Water type
        filter_raw_domestic_wastewater: [],
        filter_greywater: [],
        filter_secondary_treated_wastewater: [],
        filter_cso_discharge_water: [],
        filter_pretreated_domestic_wastewater: [],
        filter_river_diluted_wastewater: [],

        // Ratio filter
        filter_ratio: [],

        // Climate filter
        filter_ratio_tropical_climate: [],
        filter_ratio_dry_climate: [],
        filter_ratio_temperate_climate: [],
        filter_ratio_continental_climate: [],

        // Energy filter
        filter_energy:
          {
            id: "",
            name: "Energy requirements<sup><i style='font-size: 14px; margin-left:2px; cursor:default; color:#404040' class='far fa-question-circle' data-placement='right' data-toggle='tooltip' title='Check if you want to include only solutions which are considered capable of work with a low energy performance.'></i></sup>",
            tags: [["Low", "N"]],
            yes: [],
            no: []
          },

        // Modal data
        modal_elements: [
          {
            id: "c_removal",
            name: "C removal",
            description: "C removal",
            image: ""
          },
          {
            id: "n_removal_nitrateremoval",
            name: "N removal (complete, to N2)",
            description: "N removal (complete, to N2)",
            image: ""
          },
          {
            id: "n_removal_nitrification",
            name: "N removal (partial, to NO3)",
            description: "N removal (partial, to NO3)",
            image: ""
          },
          {
            id: "p_removal",
            name: "P removal (partial)",
            description: "P removal (partial)",
            image: ""
          },
        ],

        reuse:{
          es:[
            {title: "", legislation: "",
              bod: null, ecoli: null, heggs: null, tss: null, cod: null},

            {title: "Private garden watering", legislation: "1620/2007", value:{
              bod: null, ecoli: 0, heggs: 1, tss: 10, cod: null}},
            {title: "Watering of urban green areas; street streams; anti-fire systems: vehicle washing", legislation: "1620/2007", value:{
              bod: null, ecoli: 200, heggs: 1, tss: 20, cod: null}},
            {title: "Crops for human food that is ingested raw in which the edible part is is contact with the regenerated water and for tubers eaten raw", legislation: "2020/741", value:{
              bod: null, ecoli: 10, heggs: 1, tss: 20, cod: null}},

            {title: "Crops for human food that is ingested raw in which the edible part is produced above the soil level and is not in contact with the regenerated water; processed food crops; not human feeding crops including those for meat and milk animals. Type of irrigation: all types except drip irrigation.", legislation: "2020/741", value:{
              bod: null, ecoli: 100, heggs: 1, tss: 35, cod: null}},
            {title: "Crops for human food that is ingested raw in which the edible part is produced above the soil level and is not in contact with the regenerated water; processed food crops; not human feeding crops including those for meat and milk animals. Type of irrigation: drip irrigaction.", legislation: "2020/741", value:{
              bod: null, ecoli: 1000, heggs: 1, tss: null, cod: null}},
            {title: "Wood crops; ornamental flower crops; industrial crops; seed crops; energy-producing crops", legislation: "2020/741", value:{
              bod: null, ecoli: 10000, heggs: 1, tss: 35, cod: null}},
            {title: "Cleaning and process water except for human feeding industry; other industrial applications.", legislation: "1620/2007", value:{
              bod: null, ecoli: 10000, heggs: 1, tss: 35, cod: null}},
            {title: "Cleaning and process water for human feeding industry", legislation: "1620/2007", value:{
              bod: null, ecoli: 0, heggs: 1, tss: 35, cod: null}},
            {title: "Refrigeration towers and evaporative condensers", legislation: "1620/2007", value:{
              bod: null, ecoli: 0, heggs: 1, tss: 5, cod: null}},

            {title: "Golf field watering", legislation: "1620/2007", value:{
              bod: null, ecoli: 200, heggs: 1, tss: 20, cod: null}},
            {title: "Ponds, ornamental water bodies without public access.", legislation: "1620/2007", value:{
              bod: null, ecoli: 10000, heggs: null, tss: 35, cod: null}},
            {title: "Reload of aquifers via percolation through the soil.", legislation: "1620/2007", value:{
              bod: null, ecoli: 1000, heggs: null, tss: 35, cod: null}},
            {title: "Reload of aquifers via direct injection.", legislation: "1620/2007", value:{
              bod: null, ecoli: 0, heggs: 1, tss: 10, cod: null}},
            {title: "Watering of forests and green areas non accessible to the public, silviculture.", legislation: "1620/2007", value:{
              bod: null, ecoli: null, heggs: null, tss: 35, cod: null}}
          ],
          fr:[
            {title: "", legislation: "", value: { bod: null, ecoli: null, heggs: null, tss: null, cod: null}},

            {title: "Market products, fruits and vegetables not undergoing an appropriate industrial heat treatment (except cressiculture) (class A)", legislation: "Arrêté du 2 août 2010 relatif à l'utilisation d'eaux issues du traitement d'épuration des eaux résiduaires urbaines pour l'irrigation de cultures ou d'espaces verts", value: { bod: null, ecoli: 250, heggs: null, tss: 15, cod: 60}},
            {title: "Green spaces open to the public (class A)", legislation: "Arrêté du 2 août 2010 relatif à l'utilisation d'eaux issues du traitement d'épuration des eaux résiduaires urbaines pour l'irrigation de cultures ou d'espaces verts", value: { bod: null, ecoli: 250, heggs: null, tss: 15, cod: 60}},
            {title: "Market products, fruits and vegetables processed by an appropriate industrial heat treatment (class A and B)", legislation: "Arrêté du 2 août 2010 relatif à l'utilisation d'eaux issues du traitement d'épuration des eaux résiduaires urbaines pour l'irrigation de cultures ou d'espaces verts", value: { bod: null, ecoli: 10000, heggs: null, tss: 15, cod: 60}},
            {title: "Pasture; fresh fodder (class A and B; B with exceptions regarding days remaining to slaughter of livestock) ", legislation: "Arrêté du 2 août 2010 relatif à l'utilisation d'eaux issues du traitement d'épuration des eaux résiduaires urbaines pour l'irrigation de cultures ou d'espaces verts", value: { bod: null, ecoli: 10000, heggs: null, tss: 15, cod: 60}},
            {title: "Cut flowers (class A and B; for B only localised irrigation allowed) ", legislation: "Arrêté du 2 août 2010 relatif à l'utilisation d'eaux issues du traitement d'épuration des eaux résiduaires urbaines pour l'irrigation de cultures ou d'espaces verts", value: { bod: null, ecoli: 10000, heggs: null, tss: 15, cod: 60}},
            {title: "Nurseries and shrubs and other floral crops; other cereal and forage crops (class A, B, C; for C  only localised irrigation allowed)", legislation: "Arrêté du 2 août 2010 relatif à l'utilisation d'eaux issues du traitement d'épuration des eaux résiduaires urbaines pour l'irrigation de cultures ou d'espaces verts", value: { bod: null, ecoli: 100000, heggs: null, tss: 15, cod: 60}},
            {title: "Fruit arboriculture (class A, B, C; exceptions: for B: prohibited during the period from flowering to harvesting for unprocessed fruit unless drip irrigation is used; for C: only drip irrigation allowed)", legislation: "Arrêté du 2 août 2010 relatif à l'utilisation d'eaux issues du traitement d'épuration des eaux résiduaires urbaines pour l'irrigation de cultures ou d'espaces verts", value: { bod: null, ecoli: null, heggs: null, tss: 15, cod: 60}},
            {title: "Short rotation or very short rotation coppice with controlled public access (class A, B, C, D; for C and D only localised irrigation allowed)", legislation: "Arrêté du 2 août 2010 relatif à l'utilisation d'eaux issues du traitement d'épuration des eaux résiduaires urbaines pour l'irrigation de cultures ou d'espaces verts", value: { bod: null, ecoli: null, heggs: null, tss: 15, cod: 60}},
          ],
          au:[
            {title: "", legislation: "", value: { bod: null, ecoli: null, heggs: null, tss: null, cod: null}},

            {title: "Dual recirculation, toilet flushing, washing machines, garden use", legislation: "National Guidelines for Water Recycling: Managing Health and Environmental Risks. November 2006 Table 3.8", value: { bod: null, ecoli: 1, heggs: null, tss: null, cod: null}},
            {title: "Municipal use: open spaces, sports grounds, dust suppression, etc or unrestricted access and application", legislation: "National Guidelines for Water Recycling: Managing Health and Environmental Risks. November 2006 Table 3.8", value: { bod: null, ecoli: 1, heggs: null, tss: null, cod: null}},
            {title: "Municipal use, with restricted  access and application", legislation: "National Guidelines for Water Recycling: Managing Health and Environmental Risks. November 2006 Table 3.8", value: { bod: 20, ecoli: 100, heggs: null, tss: 30, cod: null}},
            {title: "Municipal use, with enhanced restrictions on access and application", legislation: "National Guidelines for Water Recycling: Managing Health and Environmental Risks. November 2006 Table 3.8", value: { bod: 20, ecoli: 1000, heggs: null, tss: 30, cod: null}},
            {title: "Landscape irrigation — trees, shrubs, public gardens, etc", legislation: "National Guidelines for Water Recycling: Managing Health and Environmental Risks. November 2006 Table 3.8", value: { bod: 20, ecoli: 1000, heggs: null, tss: 30, cod: null}},
            {title: "Commercial food crops consumed raw or unprocessed", legislation: "National Guidelines for Water Recycling: Managing Health and Environmental Risks. November 2006 Table 3.8", value: { bod: null, ecoli: 1, heggs: null, tss: null, cod: null}},
            {title: "Commercial food crops", legislation: "National Guidelines for Water Recycling: Managing Health and Environmental Risks. November 2006 Table 3.8", value: { bod: 20, ecoli: 100, heggs: null, tss: 30, cod: null}},
            {title: "Nonfood crops — trees, turf, woodlots, flowers", legislation: "National Guidelines for Water Recycling: Managing Health and Environmental Risks. November 2006 Table 3.8", value: { bod: null, ecoli: 10000, heggs: null, tss: null, cod: null}},
            {title: "Livestock drinking water", legislation: "National Guidelines for Water Recycling: Managing Health and Environmental Risks. November 2006 Table 3.9", value: { bod: 20, ecoli: 100, heggs: null, tss: 30, cod: null}},
            {title: "Dairy shed wash down", legislation: "National Guidelines for Water Recycling: Managing Health and Environmental Risks. November 2006 Table 3.9", value: { bod: 20, ecoli: 100, heggs: null, tss: 30, cod: null}},
            {title: "Pasture or fodder crop irrigation (including hay, silage and commercial fodder production). Limited withholding period", legislation: "National Guidelines for Water Recycling: Managing Health and Environmental Risks. November 2006 Table 3.9", value: { bod: 20, ecoli: 100, heggs: null, tss: 30, cod: null}},
            {title: "Pasture or fodder crop irrigation (including hay, silage and commercial fodder production). With withholding period", legislation: "National Guidelines for Water Recycling: Managing Health and Environmental Risks. November 2006 Table 3.9", value: { bod: 20, ecoli: 1000, heggs: null, tss: 30, cod: null}},
          ],
          cd:[
            {title: "", legislation: "", value: { bod: null, ecoli: null, heggs: null, tss: null, cod: null}},

            {title: "Recreation water (Primary-contact recreation)", legislation: "Guidelines for Canadian Recreational Water Quality. Third Edition. 2012. Table 1.", value: { bod: null, ecoli: 200, heggs: null, tss: null, cod: null}},
          ],
          jp:[
            {title: "", legislation: "", value: { bod: null, ecoli: null, heggs: null, tss: null, cod: null}},

            {title: "Toilet flushing water", legislation: "Establishment of guidelines for reuse of treated wastewater. 2007.", value: { bod: null, ecoli: 0, heggs: null, tss: null, cod: null}},
            {title: "Sprinkling water", legislation: "Establishment of guidelines for reuse of treated wastewater. 2007.", value: { bod: null, ecoli: 0, heggs: null, tss: null, cod: null}},
            {title: "Water for landscape use", legislation: "Establishment of guidelines for reuse of treated wastewater. 2007.", value: { bod: 10, ecoli: 1000, heggs: null, tss: null, cod: null}},
            {title: "Water for recreational use", legislation: "Establishment of guidelines for reuse of treated wastewater. 2007.", value: { bod: 3, ecoli: 0, heggs: null, tss: null, cod: null}},
          ],
          ke:[
            {title: "", legislation: "", value: { bod: null, ecoli: null, heggs: null, tss: null, cod: null}},

            {title: "Irrigation of crops for raw food, sports fields, public parks, cereal crops, industrial crops, fodder crops, pasture and trees", legislation: "Water quality regulations legal notice 120 2006.", value: { bod: null, ecoli: null, heggs: 1, tss: null, cod: null}},
            {title: "Recreational waters", legislation: "Water quality regulations legal notice 120 2006.", value: { bod: null, ecoli: null, heggs: 0, tss: null, cod: null}},
          ],
          mo:[
            {title: "", legislation: "", value: { bod: null, ecoli: null, heggs: null, tss: null, cod: null}},

            {title: "Irrigation of crops for raw food, sports fields, public parks, cereal crops, industrial crops, fodder crops, pasture and trees", legislation: "Arrêté conjoint du ministre de l'équipement et du ministre chargé de l'aménagement du territoire, de l'urbanisme, de l'habitat et de l'environnement n° 1276-01 du 10 chaabane 1423 (17 octobre 2002) portant fixation des normes de qualité des eaux destinées à l'irrigation", value: { bod: null, ecoli: null, heggs: 0, tss: null, cod: null}},
          ],
          sa:[
            {title: "", legislation: "", value: { bod: null, ecoli: null, heggs: null, tss: null, cod: null}},

            {title: "Domestic use", legislation: "South Africa water quality guidelines, Second Edition, 1996. Volume 1", value: { bod: null, ecoli: 0, heggs: null, tss: null, cod: null}},
            {title: "Recreational uses, full contact recreation (swimming)", legislation: "South Africa water quality guidelines, Second Edition, 1996. Volume 2", value: { bod: null, ecoli: 0, heggs: null, tss: null, cod: null}},
            {title: "Cooling water (evaporative high recycling), HP Steam generation, Process water (phase separation, petrochemicals, pharmaceuticals)) and Wash water (no residuals electronic parts)", legislation: "South Africa water quality guidelines, Second Edition, 1996. Volume 3", value: { bod: null, ecoli: null, heggs: null, tss: 3, cod: 10}},
            {title: "Heat exchange, HP Steam generation, Process water (solvent agent, heat transfer medium, hmidification, lubrication, gas cleaning), Product water", legislation: "South Africa water quality guidelines, Second Edition, 1996. Volume 3", value: { bod: null, ecoli: null, heggs: null, tss: 5, cod: 15}},
            {title: "Cooling water (evaporative cooling once through, bearing cooling, mould cooling), LP Steam generation, Process water (solvent, dilution agent, transport agent, gland seal, vacuum seal, lubrication, descaling, gas scrubbing), Product water (beverages, food products, baking, chemicals), Utility water (surface washing, domestic use, fire fighting)", legislation: "South Africa water quality guidelines, Second Edition, 1996. Volume 3", value: { bod: null, ecoli: null, heggs: null, tss: 5, cod: 30}},
            {title: "Cooling water (ash quenching), Process water (transport agent), Utility water (dust suspension, fire fighting, irrigation), Wash water (rough washing)", legislation: "South Africa water quality guidelines, Second Edition, 1996. Volume 3", value: { bod: null, ecoli: null, heggs: null, tss: 25, cod: 75}},
            {title: "General crops for human consumption", legislation: "South Africa water quality guidelines, Second Edition, 1996. Volume 4", value: { bod: null, ecoli: 1, heggs: null, tss: 50, cod: null}},
            {title: "Livestock feeding", legislation: "South Africa water quality guidelines, Second Edition, 1996. Volume 5", value: { bod: null, ecoli: 200, heggs: null, tss: null, cod: null}},
          ],
          epa:[
            {title: "", legislation: "", value: { bod: null, ecoli: null, heggs: null, tss: null, cod: null}},

            {title: "nonpotable applications in municipal settings where public access is not restricted.", legislation: "EPA Guidelines for water reuse 2012", value: { bod: 10, ecoli: 0, heggs: null, tss: null, cod: null}},
            {title: "nonpotable applications in municipal settings where public access is controlled or restricted by physical or institutional barriers, such as fencing, advisory signage, or temporal access restriction", legislation: "EPA Guidelines for water reuse 2012", value: { bod: 30, ecoli: 200, heggs: null, tss: 30, cod: null}},
            {title: "surface or spray irrigation of food crops which are intended for human consumption, consumed raw.", legislation: "EPA Guidelines for water reuse 2012", value: { bod: 10, ecoli: 0, heggs: null, tss: null, cod: null}},
            {title: "surface irrigation of food crops which are intended for human consumption, commercially processed.", legislation: "EPA Guidelines for water reuse 2012", value: { bod: 30, ecoli: 200, heggs: null, tss: 30, cod: null}},
            {title: "irrigation of crops which are not consumed by humans, including fodder, fiber, and seed crops, or to irrigate pasture land, commercial nurseries, and sod farms.", legislation: "EPA Guidelines for water reuse 2012", value: { bod: 30, ecoli: 200, heggs: null, tss: 30, cod: null}},
            {title: "impoundment in which no limitations are imposed on body-contact.", legislation: "EPA Guidelines for water reuse 2012", value: { bod: 10, ecoli: 0, heggs: null, tss: null, cod: null}},
            {title: "impoundment where body-contact is restricted.", legislation: "EPA Guidelines for water reuse 2012", value: { bod: 30, ecoli: 200, heggs: null, tss: 30, cod: null}},
            {title: "to create wetlands, enhance natural wetlands, or sustain stream flows.", legislation: "EPA Guidelines for water reuse 2012", value: { bod: 30, ecoli: 200, heggs: null, tss: 30, cod: null}},
            {title: "Cooling towers", legislation: "EPA Guidelines for water reuse 2012", value: { bod: 30, ecoli: 200, heggs: null, tss: 30, cod: null}},
            {title: "Groundwater recharge and augmentation of surface water for supply reservoirs.", legislation: "EPA Guidelines for water reuse 2012", value: { bod: null, ecoli: 0, heggs: null, tss: null, cod: null}},
          ],
          un:[
            {title: "", legislation: "", value: { bod: null, ecoli: null, heggs: null, tss: null, cod: null}},

            {title: "Irrigation of root crops", legislation: "Guidelines for the safe use of wastewater, excreta and greywater 2006", value: { bod: null, ecoli: 1000, heggs: 1, tss: null, cod: null}},
            {title: "Irrigation of leaf crops, labour-intensice and high-contact agriculture", legislation: "Guidelines for the safe use of wastewater, excreta and greywater 2006", value: { bod: null, ecoli: 10000, heggs: 1, tss: null, cod: null}},
            {title: "Drip irrigation, irrigation of high-growing crops, highly mechanized agriculture", legislation: "Guidelines for the safe use of wastewater, excreta and greywater 2006", value: { bod: null, ecoli: 100000, heggs: 1, tss: null, cod: null}},
            {title: "Aquaculture", legislation: "Guidelines for the safe use of wastewater, excreta and greywater 2006", value: { bod: null, ecoli: 10000, heggs: 1, tss: null, cod: null}},
          ]
        },
        // Reuse data:
        countries: [
          {
            label: 'Countries',
            options: [
              { value: null, text: 'Select an option' },
              { value: 'au', text: 'Australia' },
              { value: 'cd', text: 'Canada' },
              { value: 'fr', text: 'France' },
              { value: 'jp', text: 'Japan' },
              { value: 'ke', text: 'Kenya' },
              { value: 'mo', text: 'Morocco' },
              { value: 'sa', text: 'South Africa' },
              { value: 'es', text: 'Spain'}
              ]
          },
          {
            label: 'Institutions',
            options: [
              { value: null, text: 'Select an option' },
              { value: 'epa', text: 'EPA' },
              { value: 'un', text: 'UN WHO' },
            ]
          },
        ],
        techs_filtered: [],
        surface_data: [],
        estimate_surface: false,
        factor_PE: {
          any_wastewater: 1,
          raw_domestic_wastewater: 1,
          greywater: 0.33230769,
          secondary_treated_wastewater: 0.05,
          cso_discharge_water: 1,
          pretreated_domestic_wastewater: 0.8,
          river_diluted_wastewater: 0.05
        }
      }
    },
    mounted(){
      /* set up XMLHttpRequest */

      let _this = this;
      var url = "/excel/filtering3.xlsx";
      var oReq = new XMLHttpRequest();
      oReq.open("GET", url, true);
      oReq.responseType = "arraybuffer";

      oReq.onload = function(e) {
        var arraybuffer = oReq.response;

        /* convert data to binary string */ // WHY?
        var data = new Uint8Array(arraybuffer);
        var arr = new Array();
        for(var i = 0; i !== data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        var bstr = arr.join("");

        /* Call XLSX */
        var workbook = XLSX.read(bstr, {type:"binary"});

        /* DO SOMETHING WITH workbook HERE */
        var first_sheet_name = workbook.SheetNames[0];
        /* Get worksheet */
        var worksheet = workbook.Sheets[first_sheet_name];

        // console.log(worksheet);

        _this.technologies.push(XLSX.utils.sheet_to_json(worksheet,{raw:true}));
        _this.technologies_alpha.push(XLSX.utils.sheet_to_json(worksheet,{raw:true}));
        _this.technologies_cost.push(XLSX.utils.sheet_to_json(worksheet,{raw:true}));
        _this.technologies_cobenefits.push(XLSX.utils.sheet_to_json(worksheet,{raw:true}));
        _this.technologies_operation.push(XLSX.utils.sheet_to_json(worksheet,{raw:true}));

        _this.technologies_alpha[0].sort(function (firstTec, secondTec) {
          //console.log(firstTec.name , secondTec.name,firstTec.name > secondTec.name)
          if (firstTec.name.toUpperCase() < secondTec.name.toUpperCase()) return -1;
          if (firstTec.name.toUpperCase() > secondTec.name.toUpperCase()) return 1;
          return 0;
        });
        _this.technologies_alpha[0].forEach(tech => {
          _this.techs_filtered.push(tech.id)
        })
        _this.getData();

        _this.technologies_operation[0].sort(function (firstTec, secondTec) {
          //console.log(firstTec.name , secondTec.name,firstTec.name > secondTec.name)

          let firstSkilledVal = 0;
          let secondSkilledVal = 0;

          if(firstTec["inv_es_skills"].trim() === 'H') firstSkilledVal=3;
          if(secondTec["inv_es_skills"].trim() === 'H') secondSkilledVal=3;

          if(firstTec["inv_es_skills"].trim() === 'M') firstSkilledVal=2;
          if(secondTec["inv_es_skills"].trim() === 'M') secondSkilledVal=2;

          if(firstTec["inv_es_skills"].trim() === 'L') firstSkilledVal=1;
          if(secondTec["inv_es_skills"].trim() === 'L') secondSkilledVal=1;


          if (firstSkilledVal < secondSkilledVal) return -1;
          if (firstSkilledVal > secondSkilledVal) return 1;
          return 0;
        });

        _this.technologies_cobenefits[0].sort(function (firstTec, secondTec) {
          //console.log(firstTec.name , secondTec.name,firstTec.name > secondTec.name)
          let firstVal = 0;
          let secondVal = 0;
          for(let propt in firstTec){
            if(propt.startsWith("es_")){
              if(firstTec[propt] === 'H') firstVal+=3;
              if(secondTec[propt] === 'H') secondVal+=3;

              if(firstTec[propt] === 'M') firstVal+=2;
              if(secondTec[propt] === 'M') secondVal+=2;

              if(firstTec[propt] === 'L') firstVal+=1;
              if(secondTec[propt] === 'L') secondVal+=1;
            }
          }

          if (firstVal > secondVal) return -1;
          if (firstVal < secondVal) return 1;
          return 0;
        });

        _this.technologies_cost[0].sort(function (firstTec, secondTec) {
          //console.log(firstTec.name , secondTec.name,firstTec.name > secondTec.name)

          let firstManpowerVal = 0;
          let secondManpowerVal = 0;

          let firstSkilledVal = 0;
          let secondSkilledVal = 0;

          let firstEnergyVal = 0;
          let secondEnergyVal = 0;

          let firstVal = 0;
          let secondVal = 0;

          if(firstTec["inv_es_manpower"].trim() === 'H') firstManpowerVal=3;
          if(secondTec["inv_es_manpower"].trim() === 'H') secondManpowerVal=3;

          if(firstTec["inv_es_manpower"].trim() === 'M') firstManpowerVal=2;
          if(secondTec["inv_es_manpower"].trim() === 'M') secondManpowerVal=2;

          if(firstTec["inv_es_manpower"].trim() === 'L') firstManpowerVal=1;
          if(secondTec["inv_es_manpower"].trim() === 'L') secondManpowerVal=1;

          if(firstTec["inv_es_skills"].trim() === 'H') firstSkilledVal=3;
          if(secondTec["inv_es_skills"].trim() === 'H') secondSkilledVal=3;

          if(firstTec["inv_es_skills"].trim() === 'M') firstSkilledVal=2;
          if(secondTec["inv_es_skills"].trim() === 'M') secondSkilledVal=2;

          if(firstTec["inv_es_skills"].trim() === 'L') firstSkilledVal=1;
          if(secondTec["inv_es_skills"].trim() === 'L') secondSkilledVal=1;

          if(firstTec["energy"].trim() === 'Y') firstEnergyVal=2;
          if(secondTec["energy"].trim() === 'Y') secondEnergyVal=2;

          if(firstTec["energy"].trim() === 'N') firstEnergyVal=1;
          if(secondTec["energy"].trim() === 'N') secondEnergyVal=1;

          firstVal = firstManpowerVal * firstSkilledVal;
          secondVal = secondManpowerVal * secondSkilledVal;

          if (firstVal < secondVal) return -1;
          if (firstVal > secondVal) return 1;
          return 0;
        });


        // console.log();

        // Save all technologies data
        _this.technologies[0].forEach(function (t) {

          // Tags
          if (t.c_removal !== 'inactive') {
            _this.filter_c_removal.push(t.id);
          }
          if (t.n_removal_nitrification !== 'inactive') {
            _this.filter_n_removal_nitrification.push(t.id);
          }
          if (t.n_removal_nitrateremoval !== 'inactive') {
            _this.filter_n_removal_nitrateremoval.push(t.id);
          }
          if (t.p_removal !== 'inactive') {
            _this.filter_p_removal.push(t.id);
          }

          // Household/building solutions
          if (t.household_building_solutions !== 'inactive') {
            _this.filter_household_building_solutions.push(t.id);
          }

          // Type of water
          if (t.raw_domestic_wastewater !== 'inactive') {
            _this.filter_raw_domestic_wastewater.push(t.id);
          }
          if (t.greywater !== 'inactive') {
            _this.filter_greywater.push(t.id);
          }
          if (t.secondary_treated_wastewater !== 'inactive') {
            _this.filter_secondary_treated_wastewater.push(t.id);
          }
          if (t.cso_discharge_water !== 'inactive') {
            _this.filter_cso_discharge_water.push(t.id);
          }
          if (t.pretreated_domestic_wastewater !== 'inactive') {
            _this.filter_pretreated_domestic_wastewater.push(t.id);
          }
          if (t.river_diluted_wastewater !== 'inactive') {
            _this.filter_river_diluted_wastewater.push(t.id);
          }

          // Climate
          /*if (t.ratio_tropical_climate == 'active') {
              app2.filter_ratio_tropical_climate.push(t.id);
          }
          if (t.ratio_dry_climate == 'active') {
              app2.filter_ratio_dry_climate.push(t.id);
          }
          if (t.ratio_temperate_climate == 'active') {
              app2.filter_ratio_temperate_climate.push(t.id);
          }
          if (t.ratio_continental_climate == 'active') {
              app2.filter_ratio_continental_climate.push(t.id);
          }*/

          // Energy
          if (t.energy === 'Y') {
            _this.filter_energy.yes.push(t.id);
          }
          else { // t.energy == 'N'
            _this.filter_energy.no.push(t.id);
          }
        });


      };
      oReq.send();

      oReq.addEventListener('loadend', function () {

        $('[data-toggle="tooltip"]').tooltip();
        // document.querySelector('#orders').addEventListener('change', function () {
        //   _this.filtering();
        // });
      });



    },
    methods: {
      levelsCalc(id,case_tech_type,case_tech_subtype){
        return{
          level2: {
            linear: this.calcLinear(id, case_tech_type, case_tech_subtype),
            square: this.calcSquare(id, case_tech_type, case_tech_subtype),
            exponential: this.calcExponential(id, case_tech_type, case_tech_subtype)
          },
          level1: {
            linear: this.calcLinear(id, case_tech_type, ""),
            square: this.calcSquare(id, case_tech_type, ""),
            exponential: this.calcExponential(id, case_tech_type, "")
          },
          level0: {
            linear: this.calcLinear(id, "", ""),
            square: this.calcSquare(id, "", ""),
            exponential: this.calcExponential(id, "", "")
          },
        }
      },
      foo: function(item) {
        let _this = this;

        var possibleTags = false;
        var i = 0;
        var checkedAll = _this.checkedTags.concat(_this.checkedType);

        if(checkedAll.length > 0) {
          while(item[checkedAll[i]] !== 'possible' && i<checkedAll.length) {
            i++;
          }

          if(item[checkedAll[i]] === 'possible') {
            possibleTags = true;
          }

          let elem = document.getElementById(item.id+'_not_recom');

          if (possibleTags) {
            if (elem == null) {
              var node = document.createElement("i");
              node.classList.add("fas","fa-info-circle","info-icon");
              node.setAttribute('id', item.id+'_not_recom');
              node.setAttribute('data-toogle',"tooltip");
              node.setAttribute('title', 'This option is possible but only applicable under certain conditions');
              //console.log("test",item.id,"test", document.getElementById(item.id+'_title'));
              document.getElementById(item.id.trim()+'_title').appendChild(node);
            }
          }
          else {
            if(elem != null) {
              elem.parentNode.removeChild(elem);
            }
          }
        }
        else {
          var elem = document.getElementById(item.id+'_not_recom');
          if(elem != null) {
            elem.parentNode.removeChild(elem);
          }
        }
        let elemNotRecomended = document.getElementById(item.id.trim().replace(' ','_')+'_not_recom');
        if(item.id.trim() === "Intensified aeration" && _this.checkedType === "raw_domestic_wastewater"){
          if (elemNotRecomended == null) {
            let node = document.createElement("i");
            node.classList.add("fas","fa-info-circle","info-icon");
            node.setAttribute('id', item.id.trim().replace(' ','_')+'_not_recom');
            node.setAttribute('title', 'This option is only possible if applied to enhance the french constructed wetland');
            //data-toggle="tooltip" data-placement="bottom"
            node.setAttribute('data-toggle','tooltip');
            node.setAttribute('data-placement','bottom');

            document.getElementById('Intensified_aeration_CW_not_recom');
            document.getElementById(item.id.trim()+'_title').appendChild(node);
            //console.log(item.id.trim().replace(' ','_')+'_not_recom');
            $('#'+item.id.trim().replace(' ','_')+'_not_recom').tooltip();
          }
        }
        else {
          if(elemNotRecomended != null) {
            elemNotRecomended.parentNode.removeChild(elemNotRecomended);
          }
        }

        return true;
      },
      // Function called on click to filter elements
      filtering: function() {

        let _this = this;
        //console.log("Checked Type:",app2.checkedType);
        // if((_this.checkedType === 'greywater')){
        //   let arr = _this.checkedTags.filter(e => e !== 'n_removal_nitrateremoval');
        //   console.log(arr);
        //   app2.checkedTags = arr;
        // }



        // If no checkboxes are checked, show all elements
        if((_this.checkedTags.length == 0) && (_this.checkedType.length == 0) && (_this.checkedClimate.length == 0) &&
            (_this.inhabitants_input.length == 0) && (_this.checkedHousehold.length == 0) && (_this.area_input.length == 0) &&
            (_this.checkedEnergy.length == 0)) {

          _this.technologies_printed[0].forEach(function (t) {
            document.getElementById(t.id).style.display='';
          });

        }
        // If at least one checkbox checked,
        else {

          // hide all technologies to show the filtered
          _this.technologies_printed[0].forEach(function (t) {
            document.getElementById(t.id).style.display='none';
          });

          // Declaration of the sets of every filter
          var tagsSet = new Set();
          var householdSet = new Set();
          var typeSet = new Set();
          var ratioSet = new Set();
          var energySet = new Set();

          // The filters selected
          var sets = [];

          // Tags Set
          _this.technologies_printed[0].forEach(function (t)
          {
            let allTagsFound = true;
            _this.checkedTags.forEach(function (c) {
              if(allTagsFound){
                if (c === 'c_removal') {
                  if(t.c_removal === 'active'){
                    allTagsFound = true;
                  }
                  else allTagsFound = false;
                }
                if (c === 'n_removal_nitrification') {
                  if(t.n_removal_nitrification === 'active'){
                    allTagsFound = true;
                  }
                  else allTagsFound = false;
                }
                if (c === 'n_removal_nitrateremoval') {
                  if(t.n_removal_nitrateremoval === 'active'){
                    allTagsFound = true;
                  }
                  else allTagsFound = false;
                }
                if (c === 'p_removal') {
                  if(t.p_removal === 'active'){
                    allTagsFound = true;
                  }
                  else allTagsFound = false;
                }
              }
            });
            if(allTagsFound){
              tagsSet = new Set([...tagsSet, ...[t.id]]);
            }
          });
          //console.log(tagsSet);
          _this.checkedTags.forEach(function (c) {

            // if (c == 'c_removal') {
            //     var aux = new Set(app2.filter_c_removal);
            //     tagsSet = new Set([...tagsSet, ...aux]);
            // }
            // else if (c == 'n_removal_nitrification') {
            //     var aux = new Set(app2.filter_n_removal_nitrification);
            //     tagsSet = new Set([...tagsSet, ...aux]);
            // }
            // else if (c == 'n_removal_nitrateremoval') {
            //     var aux = new Set(app2.filter_n_removal_nitrateremoval);
            //     tagsSet = new Set([...tagsSet, ...aux]);
            // }
            // else if (c == 'p_removal') {
            //     var aux = new Set(app2.filter_p_removal);
            //     tagsSet = new Set([...tagsSet, ...aux]);
            // }
          });
          if ([...tagsSet].length != 0) sets.push(tagsSet);


          // Household Set
          _this.checkedHousehold.forEach(function (c) {
            if (c == 'household_building_solutions') {
              var aux = new Set(_this.filter_household_building_solutions);
              householdSet = new Set([...householdSet, ...aux]);
            }
          });
          if ([...householdSet].length != 0) sets.push(householdSet);


          // Water type Set
          let PE = _this.inhabitants_input;
          if (_this.checkedType == 'raw_domestic_wastewater') {
            var aux = new Set(_this.filter_raw_domestic_wastewater);
            typeSet = new Set([...typeSet, ...aux]);
            PE = _this.inhabitants_input * 60/60;
          }
          else if (_this.checkedType == 'greywater') {
            var aux = new Set(_this.filter_greywater);
            typeSet = new Set([...typeSet, ...aux]);
            PE = _this.inhabitants_input * 21/60; //60=DBO*Person*day
          }
          else if (_this.checkedType == 'secondary_treated_wastewater') {
            var aux = new Set(_this.filter_secondary_treated_wastewater);
            typeSet = new Set([...typeSet, ...aux]);
            PE = _this.inhabitants_input * 3/60;
          }
          else if (_this.checkedType == 'cso_discharge_water') {
            var aux = new Set(_this.filter_cso_discharge_water);
            typeSet = new Set([...typeSet, ...aux]);
            PE = _this.inhabitants_input * 60/60;
          }
          else if (_this.checkedType == 'pretreated_domestic_wastewater') {
            var aux = new Set(_this.filter_pretreated_domestic_wastewater);
            typeSet = new Set([...typeSet, ...aux]);
            PE = _this.inhabitants_input * 48/60;
          }
          else if (_this.checkedType == 'river_diluted_wastewater') {
            var aux = new Set(_this.filter_river_diluted_wastewater);
            typeSet = new Set([...typeSet, ...aux]);
            PE = _this.inhabitants_input * 3/60;
          }
          // console.log("PE", PE)
          if ([...typeSet].length != 0) sets.push(typeSet);

          // Ratio Set
          _this.filter_ratio = [];
          if(_this.inhabitants_input !== '' && _this.checkedClimate.length > 0) {
            //console.log("Area input:", _this.area_input);
            _this.technologies_printed[0].forEach(function (t) {
              if (_this.area_input === '' && t[_this.checkedClimate] < 1000){
                _this.filter_ratio.push(t.id);
              } else if (_this.area_input !== '' && _this.area_input/PE >= t[_this.checkedClimate]) {
                _this.filter_ratio.push(t.id);
                // console.log("Passing area filter:", t.id);
              }
            });
            //console.log('--------------------')
          }

          // Remove duplicates
          var unique = _this.filter_ratio.filter((v, i, a) => a.indexOf(v) === i);
          // Make Set
          var aux = new Set(unique);
          ratioSet = new Set([...ratioSet, ...aux]);
          //if ([...ratioSet].length != 0)
          if(_this.inhabitants_input !== '' && _this.checkedClimate.length > 0)
            sets.push(ratioSet);


          // Available energy
          _this.checkedEnergy.forEach(function (c) {
            var type;
            if (c == 'Y') {
              type = 'yes';
            }
            else if (c == 'N') {
              type = 'no';
            }

            var aux = new Set(_this.filter_energy[type]);
            energySet = new Set([...energySet, ...aux]);
          });
          if ([...energySet].length !== 0)
            sets.push(energySet);


          var intersection = new Set();

          // If only one filter selected, show its elements
          if (sets.length == 1) {
            intersection = sets[0];
            [...intersection].forEach(function (elem) {
              // console.log("elem 1 filter",elem);
              document.getElementById(elem).style.display='';
            });
          }
          // If more than one filter selected, intersect them and show the result
          else if (sets.length > 1) {

            var aux = sets[0];
            var aux2 = sets[1];
            intersection = new Set([...aux].filter(x => aux2.has(x)));

            // If more than two filter selected, intersect all
            if (sets.length > 2) {
              for (var i = 2; i < sets.length; i++) {
                intersection = new Set([...intersection].filter(x => sets[i].has(x)));
              }
            }

            // Show result
            [...intersection].forEach(function (elem) {
              // console.log("elem several filters",elem)
              document.getElementById(elem).style.display='';
            });

          }

          this.techs_filtered = [...intersection]
          console.log([...intersection]);

        }
      },
      cleanData(){
        this.dataAll = this.dataAll.filter(p=> {return p.surface > 0 && p.inflow > 0});
        for( let i = 0; i<this.dataAll.length;i++){
          this.dataAll[i].doc_data = JSON.parse(this.dataAll[i].doc_data);
        }
        //console.log(this.technologies_alpha[0]);
        this.technologies_alpha[0].forEach( technology => {
          //console.log(technology);
          technology.functionBOD = this.levelsCalc("bod",technology.type, technology.sub_type);
          technology.functionTN = this.levelsCalc("tn",technology.type, technology.sub_type);
          //technology.functionCOD = this.levelsCalc("cod",technology.type, technology.sub_type);
          technology.functionNO3 = this.levelsCalc("no3",technology.type, technology.sub_type);
          technology.functionNH4 = this.levelsCalc("nh4",technology.type, technology.sub_type);
          technology.functionTP = this.levelsCalc("tp",technology.type, technology.sub_type);
          technology.functionPO43 = this.levelsCalc("po43",technology.type, technology.sub_type);
          technology.functionECOLI = this.levelsCalc("ecoli",technology.type, technology.sub_type);
          technology.functionHEGGS = this.levelsCalc("heggs",technology.type, technology.sub_type);
          // technology.functionTN = this.lev_0_tn(technology.type, technology.sub_type);
          // if(technology.functionTN.linear.m < 0) technology.functionTN = this.lev_0_tn(technology.type, "");
          // if(technology.functionTN.linear.m < 0) technology.functionTN = this.lev_0_tn("", "");
          // technology.functionCOD = this.lev_0_cod(technology.type, technology.sub_type);
          // if(technology.functionCOD.linear.m < 0) technology.functionCOD = this.lev_0_cod(technology.type, "");
          // if(technology.functionCOD.linear.m < 0) technology.functionCOD = this.lev_0_cod("", "");
          // technology.functionNO3 = this.lev_0_no3(technology.type, technology.sub_type);
          // if(technology.functionNO3.linear.m < 0) technology.functionNO3 = this.lev_0_no3(technology.type, "");
          // if(technology.functionNO3.linear.m < 0) technology.functionNO3 = this.lev_0_no3("", "");
          // technology.functionNH4 = this.lev_0_nh4(technology.type, technology.sub_type);
          // if(technology.functionNH4.linear.m < 0) technology.functionNH4 = this.lev_0_nh4(technology.type, "");
          // if(technology.functionNH4.linear.m < 0) technology.functionNH4 = this.lev_0_nh4("", "");
          // technology.functionTP = this.lev_0_tp(technology.type, technology.sub_type);
          // if(technology.functionTP.linear.m < 0) technology.functionTP = this.lev_0_tp(technology.type, "");
          // if(technology.functionTP.linear.m < 0) technology.functionTP = this.lev_0_tp("", "");
          // technology.functionPO43 = this.lev_0_po43(technology.type, technology.sub_type);
          // if(technology.functionPO43.linear.m < 0) technology.functionPO43 = this.lev_0_po43(technology.type, "");
          // if(technology.functionPO43.linear.m < 0) technology.functionPO43 = this.lev_0_po43("", "");
          // technology.functionHEGGS = this.lev_0_heggs(technology.type, technology.sub_type);
          // if(technology.functionHEGGS.linear.m < 0) technology.functionHEGGS = this.lev_0_heggs(technology.type, "");
          // if(technology.functionHEGGS.linear.m < 0) technology.functionHEGGS = this.lev_0_heggs("", "");
          // technology.functionECOLI = this.lev_0_ecoli(technology.type, technology.sub_type);
          // if(technology.functionECOLI.linear.m < 0) technology.functionECOLI = this.lev_0_ecoli(technology.type, "");
          // if(technology.functionECOLI.linear.m < 0) technology.functionECOLI = this.lev_0_ecoli("", "");
          //console.log(technology);
        });

      },
      getData(){
        let _this = this;
        axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
        //axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;
        axios.get('https://snappAPI.icradev.cat/')
            .then(function (response) {
              // handle success
              _this.dataAll = JSON.parse(response.data.result);
              //console.log("raw array:", _this.dataAll);
              _this.cleanData();
              //console.log("raw array cleaned:", _this.dataAll);
            })
            .catch(function (error) {
              // handle error
              console.log(error);
            });
      },
      calcLinear(id,case_tech_type,case_tech_subtype) {
        //console.log(this.filteredTable(id,"lineal"))
        let filterTable = this.filteredTable(id,"lineal",case_tech_type,case_tech_subtype);
        let arrayXY = filterTable.array.filter(p =>{return (p[id+"_out"] != null) && (p[id+"_in"] != null)});
        arrayXY = arrayXY.map(p => {return {"code_cs": p.code_cs, "x": p.surface, "y": (p[id + "_in"] * p.inflow) - (p[id + "_out"] * p.inflow)}});
        // let arrayXYFiltered = arrayXY.filter(p => {return p.y > 0});
        let arrayXYFiltered = arrayXY.filter(p => {return true});
        //if (arrayXYFiltered.count === 0) error = "No enought data";
        if(true) {

          if (DEBUG_MODE) console.log(arrayXYFiltered);
          let linearRegression = this.compute_linear_regression(arrayXYFiltered);
          if (DEBUG_MODE) console.log("Lineal " + id + ": ", linearRegression);
          if( linearRegression.r_2_0.value < 0.4 ) linearRegression.error.push({id: "r2_lower", text: "( r<sup>2</sup> lower than 40% "})

          let se_x = 0;
          let sum = 0;
          arrayXY.forEach(xy => {
            sum += Math.pow(xy.x-xy.y/linearRegression.slope0.value,2)
            //sum += Math.pow(xy.y-xy.x*linearRegression.slope0.value,2)
          })
          se_x = Math.sqrt(sum/(linearRegression.number-1))
          return {
            m: linearRegression.slope0.value,
            n: 0,
            slope0: linearRegression.slope0.value,
            r_2_0: linearRegression.r_2_0,
            array: linearRegression.arrayOfPoints,
            r_2:linearRegression.r_2_0.value,
            error: linearRegression.error,
            number: linearRegression.number,
            sum,
            se_x,
            level: filterTable.level};
        }
        else{
          arrayXYFiltered = arrayXYFiltered.map(p => {return [p.x,p.y]});
          let res = ss.linearRegression(arrayXYFiltered);
          let lfunction = ss.linearRegressionLine(res);


          //console.log(res);
          return {m:res.m, n:res.b, r_2:ss.rSquared(arrayXYFiltered,lfunction)};
        }

      },
      calcSquare(id,case_tech_type,case_tech_subtype) {
        let filterTable = this.filteredTable(id,"square",case_tech_type,case_tech_subtype);
        let arrayXY = filterTable.array.filter(p =>{return p[id+"_out"] != null && p[id+"_in"] != null});
        arrayXY = arrayXY.map(p=>{ return {"code_cs":p.code_cs ,"x":p.surface, "y":(p[id+"_in"]*p.inflow)-(p[id+"_out"]*p.inflow)}});
        //let arrayXYSquared = arrayXY.filter(p=>{return (p.y > 0)});
        let arrayXYSquared = arrayXY;
        //if(arrayXYSquared.count === 0) error = "No enought data";
        arrayXYSquared = arrayXYSquared.map(p=>{return {"code":p.code_cs, "x":Math.log10(p.x), "y": Math.log10(p.y), "y_pre": p.y}});
        if(DEBUG_MODE) console.log(arrayXYSquared);
        let squarePRegression = this.compute_linear_regression(arrayXYSquared);
        if(DEBUG_MODE) console.log(squarePRegression);
        if(case_tech_subtype === 'HSSF_CW'){
          console.log("input array",arrayXYSquared)
        }

        let se_x = 0;
        let sum = 0;
        arrayXYSquared.forEach(xy => {
          sum += Math.pow(xy.x-Math.pow(10,((xy.y - squarePRegression.n.value)/squarePRegression.m.value)),2)
          //sum += Math.pow(xy.y-xy.x*linearRegression.slope0.value,2)
        })
        se_x = Math.sqrt(sum/(squarePRegression.number-1))

        squarePRegression = {
          m: squarePRegression.m.value,
          n: squarePRegression.n.value,
          slope: squarePRegression.slope0.value,
          r_2: squarePRegression.r_2.value,
          error: squarePRegression.error,
          number: squarePRegression.number,
          se_x: se_x,
          level: filterTable.level,
          //filterTable
        };
        if(DEBUG_MODE) console.log("Squared: ",squarePRegression);
        return squarePRegression;
      },
      calcExponential(id,case_tech_type,case_tech_subtype){

        let filterTable = this.filteredTable(id,"exp",case_tech_type,case_tech_subtype);
        let arrayXY = filterTable.array.filter(p =>{return (p[id+"_out"] != null) && (p[id+"_in"] != null)});
        arrayXY = arrayXY.map(p=>{ return {"code_cs":p.code_cs ,"x":p.surface, "y":(p[id+"_in"]*p.inflow)/(p[id+"_out"]*p.inflow)}});
        // arrayXY = arrayXY.filter(p=>{return p.x > 0}); //discard 0 on surface
        // let arrayXYExponential = arrayXY.filter(p=>{return (p.y > 0)});
         let arrayXYExponential = arrayXY;
        if(DEBUG_MODE) console.log(arrayXYExponential);
        arrayXYExponential = arrayXYExponential.map(p=>{return {"code":p.code_cs, "x":p.x, "y": Math.log(p.y)}});
        if(DEBUG_MODE) console.log(arrayXYExponential);
        let exponentialPRegression = this.compute_linear_regression(arrayXYExponential);
        if(DEBUG_MODE) console.log(exponentialPRegression);

        let se_x = 0;
        let sum = 0;
        arrayXYExponential.forEach(xy => {
          sum += Math.pow((-xy.y)/exponentialPRegression.slope0.value,2)
          //sum += Math.pow(xy.y-xy.x*linearRegression.slope0.value,2)
        })
        se_x = Math.sqrt(sum/(exponentialPRegression.number-1))

        exponentialPRegression = {
          m: exponentialPRegression.slope0.value,
          n:0,
          slope: exponentialPRegression.slope0.value,
          r_2:exponentialPRegression.r_2_0.value,
          // r_2:exponentialPRegression.r_2.value,
          error: exponentialPRegression.error,
          number: exponentialPRegression.number,
          level: filterTable.level,
          se_x: se_x,
        };
        if(DEBUG_MODE) console.log("Exponential: ",exponentialPRegression);
        return exponentialPRegression;
      },
      downloadAndCalc() {

        let _this = this;
        axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
        //axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;

        axios.get('http://localhost:3000/')
            .then(function (response) {
              // handle success
              let arrayRes = JSON.parse(response.data.result);
              //console.log("raw array:",arrayRes);
              let arrayXY = arrayRes.map(p=>{ return {"code_cs":p.code_cs ,"x":p.surface, "y":(p.bod_in*p.inflow)-(p.bod_out*p.inflow)}});

              arrayXY = arrayXY.filter(p=>{return p.x > 0}); //discard 0 on surface
              //console.log(arrayXY);

              //Linear
              let arrayXYFiltered = arrayXY.filter(p=>{return true});
              //console.log(arrayXYFiltered);
              //console.log("Lineal: ",_this.compute_linear_regression(arrayXYFiltered));

              //Squared
              let arrayXYSquared = arrayXY.filter(p=>{return (p.y > 0)});
              arrayXYSquared = arrayXYSquared.map(p=>{return {"code":p.code_cs, "x":Math.log(p.x), "y": Math.log(p.y)}});
              //console.log(arrayXYSquared);
              let squarePRegression = _this.compute_linear_regression(arrayXYSquared);
              //console.log(squarePRegression);
              squarePRegression = {m: squarePRegression.m.value, n:Math.exp(squarePRegression.n.value), r_2:squarePRegression.r_2.value};
              //console.log("Squared: ",squarePRegression);

              //exponential
              arrayXY = arrayRes.map(p=>{ return {"code_cs":p.code_cs ,"x":p.surface, "y":(p.bod_out*p.inflow)/(p.bod_in*p.inflow)}});
              arrayXY = arrayXY.filter(p=>{return p.x > 0}); //discard 0 on surface
              let arrayXYExponential = arrayXY.filter(p=>{return (p.y > 0)});
              arrayXYExponential = arrayXYExponential.map(p=>{return {"code":p.code_cs, "x":p.x, "y": Math.log(p.y)}});
              //console.log(arrayXYExponential);
              let exponentialPRegression = _this.compute_linear_regression(arrayXYExponential);
              //console.log(exponentialPRegression);
              exponentialPRegression = {
                m: exponentialPRegression.m.value,
                n:Math.exp(exponentialPRegression.n.value), r_2:exponentialPRegression.r_2.value};
              //console.log("Exponential: ",exponentialPRegression);
            })
            .catch(function (error) {
              // handle error
              console.log(error);
            })
            .then(function () {
              // always executed
            });
      },
      compute_linear_regression(arrayXY){
        let error = [];
        if(arrayXY.length  === 0) {
          error.push({id: "array_zero", text: "La taula d'entrada esta buida"});
        }
        let xi    = arrayXY.map(p=>Number(p.x));              //x points
        let yi    = arrayXY.map(p=>Number(p.y));              //y points
        let xi_sq = xi.map(p=>Math.pow(p,2));              //x squared points
        let yi_sq = yi.map(p=>Math.pow(p,2));              //y squared points
        let xiyi  = arrayXY.map(p=>{                          //x·y points
          return (p.x*p.y);
        });
        let N = arrayXY.length;                               //number of points
        let yiAvg = 0;
        let SSTotal = 0;
        let SSRes = 0;
        let r_2_0 = 0;
        // Standar Error SE = sb1 = sqrt [ Σ(yi - ŷi)2 / (n - 2) ] / sqrt [ Σ(xi - x)2 ]
        let se = 0;

        if(arrayXY.length>0) {
          yiAvg = yi.reduce((accumulator, p) => accumulator + Number(p))/N
          SSTotal = yi.reduce((accumulator, p) => accumulator + Math.pow((Number(p)), 2))
        }

        if(new Set(xi).size <= 3) error.push({id: "low_dipersion", text: "Poca dipersió de superfices"});

        if(DEBUG_MODE) console.log(xiyi);

        let xi_sum    = xi.sum();
        let yi_sum    = yi.sum();
        let xi_sq_sum = xi_sq.sum();
        let yi_sq_sum = yi_sq.sum();
        let xiyi_sum  = xiyi.sum();

        let slope0 = xiyi_sum/xi_sq_sum
        if(arrayXY.length > 0) {
          SSRes = arrayXY.reduce((accumulator, p) => accumulator + Math.pow(Number(p.y) - (slope0 * Number(p.x)), 2), 0)
          r_2_0 = 1 - (SSRes / SSTotal);
        }
        if(arrayXY.length>3){
          let num = Math.sqrt(arrayXY.reduce((accumulator, p) => accumulator + Math.pow(Number(p.y)-(slope0*Number(p.x)),2),0) / (N-2))
          let den = Math.sqrt(arrayXY.reduce((accumulator, p ) => accumulator + Math.pow(Number(p.x)-(xi_sum/N),2),0))
          se = num/den
        }

        if(DEBUG_MODE) console.log(xi_sum);
        if(DEBUG_MODE) console.log(yi_sum);
        if(DEBUG_MODE) console.log(xi_sq_sum);
        if(DEBUG_MODE) console.log(yi_sq_sum);
        if(DEBUG_MODE) console.log(xiyi_sum);

        //compute m and b (y = mx + n)
        if(N*(xiyi_sum) - yi_sum*xi_sum  === 0) error.push({id: "m_num_zero", text: "Numerador de la M = 0"});
        if((N*xi_sq_sum - Math.pow(xi_sum,2))  === 0) error.push({id: "m_den_zero", text: "Denominador de la M = 0"});

        let m = (N*(xiyi_sum) - yi_sum*xi_sum)/(N*xi_sq_sum - Math.pow(xi_sum,2));

        if(m.isNaN) error.push({id: "m_nan", text: "M és NaN"});

        let n = (yi_sum - m*xi_sum)/N;

        if(DEBUG_MODE) console.log("m",N,N*(xiyi_sum), (yi_sum*xi_sum),N*xi_sq_sum, Math.pow(xi_sum,2));

        //compute r (correlation)
        let r_2 = Math.pow(N*xiyi_sum - xi_sum*yi_sum, 2)/((N*xi_sq_sum - Math.pow(xi_sum,2))*(N*yi_sq_sum - Math.pow(yi_sum,2)));
        //console.log("R2, total:", r_2)
        //if(r_2 < 0.5) error.push({id: "r2_lower", text: "( r<sup>2</sup> lower than 50% "})
        if(error.length > 0) error.push({id: "num_entrades", text: "entrades = "+N});

        return {
          m:{value:m},
          n:{value:n},
          slope0: {value: slope0},
          r_2:{value:r_2 },
          r_2_0:{value:r_2_0, SSTotal, SSRes, yiAvg, se},
          number: N,
          arrayOfPoints: {xi,yi},
          error
        };
      },
      filteredTable(id,type,case_tech_type,case_tech_subtype,level = 2){
        //console.log(id,type,case_tech_type,case_tech_subtype);
        let actualData = this.dataAll;
        let lev_1_actualData = [];
        let lev_2_actualData = [];
        let _this = this;
        actualData = this.dataAll.filter(nbs => {

          //if(nbs["validated_"+id] == 0) return false;


          if(type = "lineal") {
            return ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
                ((nbs.surface > 0)) &&
                ((nbs[id + "_in"] * nbs.inflow) - (nbs[id + "_out"] * nbs.inflow)) > 0;
          }
          else if(type = "square") {
            return ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
                ((nbs.surface != null) && (nbs.surface > 0)) &&
                ((nbs[id+"_in"]*nbs.inflow)-(nbs[id+"_out"]*nbs.inflow)) > 0
          }
          else if(type = "exp") {
            return ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
                ((nbs.surface != null) && (nbs.surface > 0)) &&
                ((nbs[id+"_out"]*nbs.inflow)/(nbs[id+"_in"]*nbs.inflow)) > 0
          }
        });
        if(case_tech_type !== ""  && level > 0){
          lev_1_actualData = actualData.filter(nbs => {
            if(type = "lineal") {

              return nbs.type === case_tech_type &&
                  ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
                  ((nbs.surface != null) && (nbs.surface > 0)) &&
                  ((nbs[id + "_in"] * nbs.inflow) - (nbs[id + "_out"] * nbs.inflow)) > 0
            }
            else if(type = "square") {
              return nbs.type === case_tech_type &&
                  ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
                  ((nbs.surface != null) && (nbs.surface > 0)) &&
                  ((nbs[id+"_in"]*nbs.inflow)-(nbs[id+"_out"]*nbs.inflow)) > 0
            }
            else if(type = "exp") {
              return nbs.type === case_tech_type &&
                  ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
                  ((nbs.surface != null) && (nbs.surface > 0)) &&
                  ((nbs[id+"_out"]*nbs.inflow)/(nbs[id+"_in"]*nbs.inflow)) > 0
            }
          });
          if(case_tech_subtype !== "" && level > 1){
            lev_2_actualData = lev_1_actualData.filter(nbs => {
              if(type = "lineal") {
                return nbs.type === case_tech_type &&
                    nbs.sub_type === case_tech_subtype &&
                    ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
                    ((nbs.surface != null) && (nbs.surface > 0)) &&
                    ((nbs[id + "_in"] * nbs.inflow) - (nbs[id + "_out"] * nbs.inflow)) > 0
              }
              else if(type = "square") {
                return nbs.type === case_tech_type &&
                    nbs.sub_type === case_tech_subtype &&
                    ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
                    ((nbs.surface != null) && (nbs.surface > 0)) &&
                    ((nbs[id+"_in"]*nbs.inflow)-(nbs[id+"_out"]*nbs.inflow)) > 0
              }
              else if(type = "exp") {
                return nbs.type === case_tech_type &&
                    nbs.sub_type === case_tech_subtype &&
                    ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
                    ((nbs.surface != null) && (nbs.surface > 0)) &&
                    ((nbs[id+"_out"]*nbs.inflow)/(nbs[id+"_in"]*nbs.inflow)) > 0
              }
            });
          }
        }

        if(lev_2_actualData.length > 2) {
          lev_2_actualData = this.filterByDeviationSurface( lev_2_actualData)
          lev_2_actualData = this.filterByDeviation(id, lev_2_actualData)
          return {level: 2, array: lev_2_actualData};
        }
        else if (lev_1_actualData.length > 2) {
          //lev_1_actualData = this.filterByDeviation(id, lev_1_actualData)
          return {level: 1, array: lev_1_actualData};
        }
        //actualData = this.filterByDeviation(id, actualData)
        return {level: 0, array: actualData};
      },
      filterByDeviationSurface(dataArray){
        let acc = 0;
        let calcArray = []
        dataArray.forEach( val =>{
          //console.log(val[id+"_in"],val[id+"_out"],val.surface);
          //console.log((val[id+"_in"]*val.inflow-val[id+"_out"]*val.inflow) / val.surface)
          let calc = val.surface
          acc += calc;
          calcArray.push(calc)
        });
        let median = acc / dataArray.length;
        // console.log(acc);
        // console.log("Median", median)
        // console.log("SD", this.getStandardDeviation(calcArray))
        // console.log("SD", ss.standardDeviation(calcArray))
        let interval = 0
        if(dataArray.length >0) {
          if (dataArray.length < 15) interval = ss.standardDeviation(calcArray) * 2
          else interval = ss.standardDeviation(calcArray) * 3
        }
        let retDataArray = dataArray.filter(val =>{
          let calc = val.surface;
          return median - interval < calc && median + interval > calc;
        })
        return retDataArray;
      },
      filterByDeviation(id,dataArray){
        let acc = 0;
        let calcArray = []
        dataArray.forEach( val =>{
          //console.log(val[id+"_in"],val[id+"_out"],val.surface);
          //console.log((val[id+"_in"]*val.inflow-val[id+"_out"]*val.inflow) / val.surface)
          let calc = (val[id+"_out"]*val.inflow-val[id+"_in"]*val.inflow) / val.surface;
          acc += calc;
          calcArray.push(calc)
        });
        let median = acc / dataArray.length;
        // console.log(acc);
        // console.log("Median", median)
        // console.log("SD", this.getStandardDeviation(calcArray))
        // console.log("SD", ss.standardDeviation(calcArray))
        let interval = 0
        if(dataArray.length >0) {
          if (dataArray.length < 15) interval = ss.standardDeviation(calcArray) * 2
          else interval = ss.standardDeviation(calcArray) * 3
        }
        let retDataArray = dataArray.filter(val =>{
          let calc = (val[id+"_out"]*val.inflow-val[id+"_in"]*val.inflow) / val.surface;
          return median - interval < calc && median + interval > calc;
        })
        return retDataArray;
      },
      simplifyResult(res){
        return res.toLocaleString("es", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      },
      simplifyResultDecimals(res,maxdecimals){
        return res.toLocaleString("es", {
          minimumFractionDigits: 0,
          maximumFractionDigits: maxdecimals,
        });
      },
      stringFromLevel(level){
        switch (level) {
          case level = 2:
            return "Sub-type"
          case level = 1:
            return "Type"
          case level = 0:
            return "General"
          default:
            return "Error"
        }
      },
      calcFormula(id, functions){
        if(!functions) return {resultString: "no function"}
        let c_in = 0;
        let c_out = 0;
        //if(id === "bod") {c_in = this.inputs[id+"_in"] * this.inflow;  c_out = this.inputs[id+"_out"] * this.inflow;}
        c_in = this.inputs[id+"_in"] * this.inflow;
        c_out = this.inputs[id+"_out"] * this.inflow;

        //console.log(functions);
        let result = "none";
        let auxRes = -1;
        let level = 2;
        let type = "";
        let resultString = "None"
        let details = ""
        if(functions.level2){
          level = 2;
          //console.log(functions.level2.linear.error.length, functions.level2.square.error.length, functions.level2.exponential.error.length)
          if(functions.level2.linear.r_2 > functions.level2.square.r_2 && functions.level2.linear.r_2 > functions.level2.exponential.r_2 && functions.level2.linear.error.length === 0 ){
            // auxRes = ((c_out-c_in) - functions.level2.linear.n) / functions.level2.linear.m
            auxRes = (c_in - c_out) / functions.level2.linear.m
            type = "linear"
            resultString = `${this.simplifyResult(auxRes)} m<sup>2</sup>`
            details = `Level: ${this.stringFromLevel(functions.level2.linear.level)}, Equation: Linear, Number of cases: ${functions.level2.linear.number} r<sup>2</sup>: ${this.simplifyResultDecimals(functions.level2.linear.r_2,2)}`;
            if(functions.level2.linear.error.length > 0) resultString += ` Error: ${functions.level2.linear.error[0].id}`
          }
          else if(functions.level2.square.r_2 > functions.level2.linear.r_2 && functions.level2.square.r_2 > functions.level2.exponential.r_2 && functions.level2.square.error.length === 0){
            //console.log(c_in-c_out, functions.level2.square.n,  functions.level2.square.m);
            auxRes =  Math.pow(10,((Math.log10(c_in-c_out) - functions.level2.square.n)/functions.level2.square.m));
            type = "square"
            resultString = `${this.simplifyResult(auxRes)} m<sup>2</sup>`
            details = `Level: ${this.stringFromLevel(functions.level2.square.level)}, Equation: Potential, Number of cases: ${functions.level2.square.number} r<sup>2</sup>: ${this.simplifyResultDecimals(functions.level2.square.r_2,2)}`;
            if(functions.level2.square.error.length > 0) resultString += ` Error: ${functions.level2.square.error[0].id}`
          }
          else if(functions.level2.exponential.r_2 > functions.level2.linear.r_2 && functions.level2.exponential.r_2 > functions.level2.square.r_2 && functions.level2.exponential.error.length === 0 ){
            //console.log(c_in-c_out, functions.level2.exponential.n,  functions.level2.exponential.m);
            auxRes =  -Math.log(((c_in) / (c_out))) / functions.level2.exponential.m;
            type = "exponential"
            resultString = `${this.simplifyResult(auxRes)} m<sup>2</sup>`
            details = `Level: ${this.stringFromLevel(functions.level2.exponential.level)}, Equation: Exponential, Number of cases: ${functions.level2.exponential.number} r<sup>2</sup>: ${this.simplifyResultDecimals(functions.level2.exponential.r_2,2)}`;
            if(functions.level2.exponential.error.length > 0) resultString += ` Error: ${functions.level2.exponential.error[0].id}`
          }
        }

        if(auxRes > 0) result = {result: auxRes, level, type, resultString};
        else if(functions.level1){
          level = 1;
          console.log(id,functions,functions.level1.linear.number)
          if(functions.level1.linear.r_2 > functions.level1.square.r_2 && functions.level1.linear.r_2 > functions.level1.exponential.r_2 && functions.level1.linear.error.length === 0 ){
            auxRes = (c_in - c_out) / functions.level1.linear.m
            type = "linear";
            resultString = `${this.simplifyResult(auxRes)} m<sup>2</sup> `
            details = `Level: ${this.stringFromLevel(functions.level1.linear.level)}, Equation: Linear, Number of cases: ${functions.level1.linear.number} r<sup>2</sup>: ${this.simplifyResultDecimals(functions.level1.linear.r_2,2)}`;
            if(functions.level1.linear.error.length > 0) resultString += ` Error: ${functions.level1.linear.error[0].id}`
          }
          else if(functions.level1.square.r_2 > functions.level1.linear.r_2 && functions.level1.square.r_2 > functions.level1.exponential.r_2 && functions.level1.square.error.length === 0 ){
            //console.log(c_in-c_out, functions.level1.square.n,  functions.level1.square.m);
            //auxRes =  Math.pow(((c_in-c_out) / functions.level1.square.n), (1/functions.level1.square.m));
            auxRes =  Math.pow(10,((Math.log10(c_in-c_out) - functions.level1.square.n)/functions.level1.square.m));
            type = "square"
            resultString = `${this.simplifyResult(auxRes)} m<sup>2</sup> `
            details = `Level: ${this.stringFromLevel(functions.level1.square.level)}, Equation: Potential, Number of cases: ${functions.level1.square.number} r<sup>2</sup>: ${this.simplifyResultDecimals(functions.level1.square.r_2,2)}`;
            if(functions.level1.square.error.length > 0) resultString += ` Error: ${functions.level1.square.error[0].id}`
          }
          else if(functions.level1.exponential.r_2 > functions.level1.linear.r_2 && functions.level1.exponential.r_2 > functions.level1.square.r_2 && functions.level1.exponential.error.length === 0 ){
            //console.log(c_in-c_out, functions.level1.exponential.n,  functions.level1.exponential.m);
            auxRes =  -Math.log(((c_in) / (c_out))) / functions.level1.exponential.m;
            type = "exponential"
            resultString = `${this.simplifyResult(auxRes)} m<sup>2</sup> `
            details = `Level: ${this.stringFromLevel(functions.level1.exponential.level)}, Equation: Exponential, Number of cases: ${functions.level1.exponential.number} r<sup>2</sup>: ${this.simplifyResultDecimals(functions.level1.exponential.r_2,2)}`;
            if(functions.level1.exponential.error.length > 0) resultString += ` Error: ${functions.level1.exponential.error[0].id}`
          }
        }

        if(auxRes > 0) result = {result: auxRes, level, type, resultString};
        else if(functions.level0){
          level = 0;
          console.log(id,functions,functions.level0.linear.number)
          if(functions.level0.linear.r_2 > functions.level0.square.r_2 && functions.level0.linear.r_2 > functions.level0.exponential.r_2 && functions.level0.linear.error.length === 0 ){
            auxRes = (c_in - c_out) / functions.level0.linear.m
            type = "linear"
            resultString = `${this.simplifyResult(auxRes)} m<sup>2</sup> `
            details = `Level: ${this.stringFromLevel(functions.level0.linear.level)}, Equation: Linear, Number of cases: ${functions.level0.linear.number} r<sup>2</sup>: ${this.simplifyResultDecimals(functions.level0.linear.r_2,2)}`;
            if(functions.level0.linear.error.length > 0) resultString += ` Error: ${functions.level0.linear.error[0].id}`
          }
          else if(functions.level0.square.r_2 > functions.level0.linear.r_2 && functions.level0.square.r_2 > functions.level0.exponential.r_2 && functions.level0.square.error.length === 0 ){
            //console.log(c_in-c_out, functions.level0.square.n,  functions.level0.square.m);
            //auxRes =  Math.pow(((c_in-c_out) / functions.level0.square.n), (1/functions.level0.square.m));
            auxRes =  Math.pow(10,((Math.log10(c_in-c_out) - functions.level0.square.n)/functions.level0.square.m));
            type = "square"
            resultString = `${this.simplifyResult(auxRes)} m<sup>2</sup> `
            details = `Level: ${this.stringFromLevel(functions.level0.square.level)}, Equation: Potential, Number of cases: ${functions.level0.square.number} r<sup>2</sup>: ${this.simplifyResultDecimals(functions.level0.square.r_2,2)}`;
            if(functions.level0.square.error.length > 0) resultString += ` Error: ${functions.level0.square.error[0].id}`
          }
          else if(functions.level0.exponential.r_2 > functions.level0.linear.r_2 && functions.level0.exponential.r_2 > functions.level0.square.r_2 && functions.level0.exponential.error.length === 0 ){
            //console.log(c_in-c_out, functions.level0.exponential.n,  functions.level0.exponential.m);
            auxRes =  -Math.log(((c_in) / (c_out))) / functions.level0.exponential.m;
            type = "exponential"
            resultString = `${this.simplifyResult(auxRes)} m<sup>2</sup> `
            details = `Level: ${this.stringFromLevel(functions.level0.exponential.level)}, Equation: Exponential, Number of cases: ${functions.level0.exponential.number} r<sup>2</sup>: ${this.simplifyResultDecimals(functions.level0.exponential.r_2,2)}`;
            if(functions.level0.exponential.error.length > 0) resultString += ` Error: ${functions.level0.exponential.error[0].id}`
          }
        }
        if(auxRes > 0) result = {result: auxRes, level, type, resultString, details};
        else{
          result = {result: -1,level: -1,type: "error", resultString:"Error total"};

          console.log(functions.level0.exponential.error, auxRes)
          console.log(functions.level0.square.error, auxRes)
          console.log(functions.level0.linear.error, auxRes)
          if(functions.level0.exponential.error.length > 0 || functions.level0.square.error.length > 0 || functions.level0.linear.error.length > 0) {
            if (functions.level0.exponential.error.length > 0 && functions.level0.exponential.error[0].id === 'r2_lower') {
              result = {
                result: -1, level: -1, type: "error",
                resultString: `Not possible to estimate`,
                details: `r<sup>2</sup>: ${functions.level0.exponential.r_2}`
              };
            } else if (functions.level0.square.error.length > 0 && functions.level0.square.error[0].id === 'r2_lower') result = {
              result: -1,
              level: -1,
              type: "error",
              resultString: `Not possible to estimate`,
              details: `r<sup>2</sup>: ${this.simplifyResultDecimals(functions.level0.square.r_2, 2)}`
            };
            else if (functions.level0.linear.error.length > 0 && functions.level0.linear.error[0].id === 'r2_lower') result = {
              result: -1,
              level: -1,
              type: "error",
              resultString: `Not possible to estimate`,
              details: `r<sup>2</sup>: ${this.simplifyResultDecimals(functions.level0.linear.r_2, 2)}`
            };
            else result = {result: -1, level: -1, type: "error", resultString: "Error total"};
          }
          else result = {result: -1, level: -1, type: "error", resultString: "Error total"};
        }

        return result;
      },
      showSize(id){
        if(this.inputs[id+"_in"] === "") return false;
        if(this.inputs[id+"_out"] === "") return false;
        //console.log(id);
        if(isNaN(parseFloat(this.inputs[id+"_in"]))) return false;
        if(isNaN(parseFloat(this.inputs[id+"_out"]))) return false;
        if(parseFloat(this.inputs[id+"_in"]) < parseFloat(this.inputs[id+"_out"])) return false;
        return true;
      },
      changeInflow(val){this.inflow_pe = Math.round((val/0.12)*100)/100},
      changeInflowPE(val){this.inflow = Math.round((val*0.12)*100)/100},
      clearAllInputValues(){
        Object.keys(this.inputs).forEach(key => {
          this.inputs[key] = "";
        })
      },
      sendInputValues(){
        // parse inputs when they exist
        let polls = {}
        Object.keys(this.inputs).forEach(key => {
          if (this.inputs[key] !== '') polls[key] = Number(this.inputs[key])
        })

        let body = {
          inflow: Number(this.inflow),
          techs: this.techs_filtered,
          polls: polls
        }
        console.log("body", body)
        const endpoint = "https://snapp-multisource.icradev.cat/api/estimate-surface";
        // const endpoint = "http://localhost:8000/api/estimate-surface";
        let _this = this
        axios.post(endpoint, body)
          .then(function (res){
            console.log(res);
            _this.surface_data = res.data
            _this.estimate_surface = true
              })
          .catch(function (error){
            console.log(error)
              })
      },
      estimateArea(id, poll){
        if (this.estimate_surface == false){
          console.error("Data not available")
          return
        }

        let estimation = this.surface_data.find(e => e.tech == id && e.poll == poll)
        if (!estimation) return false

        if (estimation.surface === null) return {
          details: `There are less than five valid observations to estimate the surface for this technology removing ${poll}`,
          resultString: "--"
        }

        return {
          details: `Equation: ${estimation.type}; number of cases: ${estimation.n_obs}; R<sup>2</sup>: ${estimation.score}`,
          resultString: `${estimation.surface[0]} - ${estimation.surface[1]} m<sup>2</sup>`
        }
      },
      expertArea(id){
        if (this.checkedClimate.length == 0 || this.inhabitants_input === '') return false;

        const tech = this.technologies[0].find(e => e.id == id)
        const ratio_climate = tech[this.checkedClimate]
        // console.log("climate", ratio_climate)
        let _expertArea = ratio_climate * this.inhabitants_input * this.factor_PE[this.checkedType]
        return Math.round(_expertArea*100)/100
      }
    },
    watch:{
      reuse_sel: function (val){
        //console.log(this.reuse_sel);
        if(this.reuse_sel != null){
          if(this.reuse_sel.bod != null) this.inputs.bod_out = this.reuse_sel.bod
          else this.inputs.bod_out = ""
          if(this.reuse_sel.cod != null) this.inputs.cod_out = this.reuse_sel.cod
          else this.inputs.cod_out = ""
          if(this.reuse_sel.ecoli != null) this.inputs.ecoli_out = this.reuse_sel.ecoli
          else this.inputs.ecoli_out = ""
          if(this.reuse_sel.heggs != null) this.inputs.heggs_out = this.reuse_sel.heggs
          else this.inputs.heggs_out = ""
          //if(this.reuse_sel.tss != null) this.inputs.bod_out = this.reuse_sel.bod

          this.inputs.tn_out = "";
          this.inputs.no3_out = "";
          this.inputs.nh4_out = "";
          this.inputs.tp_out = "";
          this.inputs.po43_out = "";
        }
      },
      inhabitants_input: function (val){
        console.log("inh input", val, this.checkedType, this.factor_PE[this.checkedType])
        this.inflow = Math.round((val*0.120)*100)/100;
        this.inflow_pe = Math.round(val*100)/100
      }
    }
  }
</script>

<style scoped>

  .labelReuse{
    /* text */

    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */


    color: #5E686D;
  }

  .mediumText{
    /* text */

    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */


    color: #5E686D;
  }

  .littleText{
    /* text petit */

    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    /* or 121% */


    color: #5E686D;
  }

  .badge-primary{
    background: #00ACE5;
  }

  .legendText{
    /* text petit */

    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height, or 121% */


    color: #5E686D;
  }

  .b-icon.bi.collapsed {
    transform: rotate(180deg);
  }

  .thirdPart{
    color: white;
    background: linear-gradient(267.47deg, #BDE4F7 -89.5%, #00ACE5 96.26%);
    padding-left: 80px;
    padding-right: 80px;
  }
  .thirdPart h2{
    margin-top: 95px;
    margin-bottom: 35px;
    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 43px;
    text-align: center;
  }
  .thirdPart .third-text{
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 26px;
  }

  .thirdPart .line{
    width: 307px;
    border: 1px solid #FFFFFF;
    margin-left: auto;
    margin-bottom: 82px;
    margin-right: auto;
  }

  .buttonStyle{
    border-color: #00ACE5 !important;
    color: #00ACE5 !important;

    padding: 6px 12px;

    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 126.5%;
    /* or 20px */

    text-align: center;
    text-transform: uppercase;
  }

  .buttonStyleFact{

    /*padding: 10px 30px;*/

    width: 100%;

    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 126.5%;
    /* or 20px */

    text-align: center;
    text-transform: uppercase;
  }

  .buttonStyle:hover{
    border-color: #00ACE5 !important;
    background-color: #00ACE5 !important;
    color: white !important;
  }


  /* CONTENT */

  .content {
    max-width: 1280px;
    margin: 0 auto;
  }

  label.disabled_text {
    color: lightgrey;
  }

  .hidden {
    display: none;
  }

  .tofillSection {
    background-color: #F7F7F7;
  }

  /* FILTER */

  #widget-title {
    font-family: 'Raleway', 'Open Sans',sans-serif;
    /*width: 255px;*/
    margin-bottom: 3px;
    font-weight: 700;
    font-size: 18px;
    padding-bottom: 5px;
    text-align: left;
    text-transform: none;
  }

  .modal-button {
    background-color: #e39717;
    margin-bottom: -15px;
    padding: 15px 25px;
  }

  a.modal_button:hover {
    background-color: #FFFFFF;
    opacity: 0.5;
  }

  a.modal_button {
    padding: 15px 20px;
    display: block;
    color: #e39717;
    text-align: center;
    font-size: 18px;
    font-family: Open Sans, sans-serif;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.5s;
    background-color: white;
  }

  .form-check-label {
    cursor: pointer;
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 108.5%;
    /* or 17px */


    color: #5E686D;
  }

  /* Style the buttons inside the tab */
  .tab button {
    background-color: #3a89b4;
    float: left;
    border: 2px solid #3a89b4;
    border-bottom: none;
    outline: none;
    cursor: pointer;
    padding: 14px 16px;
    transition: 0.3s;
    font-size: 17px;
    color: #FFFFFF;
    font-weight: 700;
    border-radius: 3px;
    position: relative;
    top:2px;
    z-index: 1;
  }

  .tab #studies {
    color: #ababab;
    border: 1px solid #ababab;
    border-left: none;
    border-bottom: none;
    background-color: inherit;
  }

  .tab #factsheets {
    color: #ab585b;
    border: 1px solid #ab585b;
    color: #ababab;
    border: 1px solid #ababab;
    border-left: none;
    border-bottom: none;
    background-color: inherit;
  }


  /* SOLUTIONS */

  .caption h2, .caption .solution-content{
    padding-left: 0;
  }

  .content .col-md-3 {
    padding-right: 0px;
    padding-left: 0px;
  }

  .content .col-md-9 {
    border: 2px solid #3a89b4;
  }

  #solutions-container .col-md-4 {
    padding-top: 20px;
    padding-right: 9px;
    padding-left: 9px;
  }

  .content .row {
    margin-right: 0;
    margin-left: 0;
  }

  .solution-title {
    text-transform: none;
    text-decoration: none;
    color: #000000;
    font-size: 18px;
    padding: 0 15px;
    padding-bottom: 3px;
    margin: 0;
    margin-top: 7px;
    font-weight: 700;
    font-family: 'Raleway', 'Open Sans', sans-serif;
  }


  .solution-container:hover h2, .solution-container:hover .solution-content {
    color: #3a89b4;
  }

  .solution-content {

    font-size: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #404040;
    text-decoration: none;

  }

  #solutions-container a {
    text-decoration: none;
  }

  #solutions-container .thumbnail img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  #solutions-container a .thumbnail img {
    /*height: 160px;*/
    width: 100%;
    z-index: -1;
  }




  /* TAGS */

  span.legend {
    font-size: 9px;
    padding: 3px 3px;
    display: inline-block;
    margin: 0 3px 1px 0;
    background-color: #3a89b4;
    color: #FFFFFF;
    font-weight: 600;
  }

  span.legend.inactive {
    background-color: lightgray;
    color: whitesmoke;
  }

  .legend.c_removal, .legend.n_removal_nitrification, .legend.n_removal_nitrateremoval, .legend.p_removal, .legend.microcontaminants_removal {
    background-color: #e39717;
  }

  span.legend2 {
    font-size: 9px;
    padding: 3px 3px;
    display: inline-block;
    margin: 0 3px 1px 0;
    font-weight: 600;
    font-size: 1.2em;
  }

  span.legend2 {
    width: 6%;
    padding: 0px;
    margin: 0px;
    margin-top: 2px;
    margin-bottom: 2px;
    text-align: center;
    min-width: 30px;
  }

  span.legend2.L {
    /*color: #e37317 !important;*/
    color: darkseagreen;
  }

  span.legend2.M {
    /*color: #e3d517 !important;*/
    color: mediumseagreen;
  }

  span.legend2.H {
    /*color: #84e317 !important;*/
    color: seagreen;
  }

  span.legend2.inactive {
    color: lightgrey;
  }



  span.legend3 {
    font-size: 9px;
    padding: 3px 3px;
    display: inline-block;
    margin: 0 3px 1px 0;
    font-weight: 600;
    font-size: 1.2em;
  }

  span.legend3 {
    width: 6%;
    padding: 0px;
    margin: 0px;
    margin-top: 2px;
    margin-bottom: 2px;
    text-align: center;
    min-width: 30px;
  }

  div.legend3_rest{
    width:78%;
  }

  span.legend3.H {
    color: darkblue;
    /*color: #e37317 !important;*/
  }

  span.legend3.M {
    color: dodgerblue;
    /*color: #e3d517 !important;*/
  }

  span.legend3.L {
    color: lightblue;
    /*color: #84e317 !important;*/
  }

  .info-icon {
    color: rgb(255, 0, 0);
  }

  span.legend4.H {
    color: orangered;
    /*color: #e37317 !important;*/
  }

  span.legend4.M {
    color: orange;
    /*color: #e3d517 !important;*/
  }

  span.legend4.L {
    color: palegoldenrod;
    /*color: #84e317 !important;*/
  }
  span.legend4 {
    font-size: 9px;
    padding: 3px 3px;
    display: inline-block;
    margin: 0 3px 1px 0;
    font-weight: 600;
    font-size: 1.2em;
  }

  span.legend4 {
    width: 6%;
    padding: 0px;
    margin: 0px;
    margin-top: 2px;
    margin-bottom: 2px;
    text-align: center;
    min-width: 30px;
  }

  .labelStyle{
    /* text */

    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */


    color: #5E686D;
  }
  .input-group-text {
    min-width: 80px;
  }

</style>
<style>

  .my-legend .legend-scale ul {
    margin: 0;
    margin-bottom: 5px;
    padding: 0;
    list-style: none;
  }
  .my-legend .legend-scale ul li {
    font-size: 80%;
    list-style: none;
    margin-left: 0;
    line-height: 18px;
    margin-bottom: 2px;
  }
  .my-legend ul.legend-labels li span {
    display: block;
    float: left;
    height: 16px;
    width: 30px;
    margin-right: 5px;
    margin-left: 0;
    border: 1px solid #999;
  }
  .my-legend {
    background: #000;
  }

  .badge-secondary {
    color: #ece9e9 !important;
    background-color: #a4aeb8 !important;
  }

  .badge-custom {
    width: 100%;
    padding: 5px;
  }

  .badge-style{
    background-color: #F6F6F6;
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 26px;
    /* identical to box height, or 130% */
    text-transform: uppercase;
    color: #5E686D;
  }


</style>
